import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.cluster.deploy.item');
import { OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from 'src/libs/portal/season/service';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-cluster-deploy-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.cluster.deploy.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraClusterDeployItemComponent implements OnInit, OnDestroy {
    public id: number = 0;
    public tab: string = 'overview';
    public item: any = null;
    public nodes: any[] = [];
    public relaySubnets: any[] = [];
    public deployLogs: any[] = [];
    public operationLogs: any[] = [];
    public images: any[] = [];
    public relayImages: any[] = [];
    public loading: boolean = true;
    public refreshing: boolean = false;
    public deploymentLoading: boolean = false;
    public errorMessage: string = '';
    public deployMessage: string = '';
    public relayMessage: string = '';
    public monitoringActionMessage: string = '';
    public moreOpen: boolean = false;
    public deploymentScope: string = 'cluster';
    public selectedDeploymentGroupKey: string = '';
    public deployForm: any = { image_id: '' };
    public relayForm: any = { relay_image_id: '', computing_image_id: '' };
    public deploying: boolean = false;
    public relayServerDeploying: boolean = false;
    public relayPreflightLoading: boolean = false;
    public relayDeployStarting: boolean = false;
    public relayAllowOverride: boolean = false;
    public relayPreflightReport: any = null;
    public relayDiagnosticVisible: boolean = false;
    public relayDiagnosticExpanded: boolean = true;
    public relayDiagnosticAction: string = '';
    public relayDiagnosticStartedAt: string = '';
    public relayDiagnosticMessage: string = '';
    public relayDiagnosticCode: string = '';
    public relayOrchestrationJob: any = null;
    public relayOrchestrationJobId: string = '';
    public relayCreatedId: string = '';
    public orchestrationErrorModalOpen: boolean = false;
    public orchestrationErrorStep: any = null;
    public orchestrationErrorRows: any[] = [];
    public relayWindowGapSeconds: number = 3;
    public relayWindowSize: number = 50;
    public advancedDrawerOpen: boolean = false;
    public advancedDrawerSection: string = 'main';
    public deployMenuOpen: boolean = false;
    public nodeTypeFilter: string = 'all';
    public nodeRowsLimit: number = 100;
    public nodeSearchText: string = '';
    public selectedNodeIds: any = {};
    public expandedNodeTreeGroups: any = {};
    public nodesFilter: any = {
        role: '',
        dhcp_role: '',
        assigned_relay_id: '',
        status: '',
        rack_key: '',
        text: '',
    };
    public nodesPage: number = 1;
    public nodesPageSize: number = 25;
    public readonly nodesPageSizeOptions: number[] = [10, 25, 50, 100];
    public nodesExporting: boolean = false;
    public nodeStatusFilters: any = {
        all: true,
        deployed: false,
        in_progress: false,
        failed: false,
        pending: false,
    };
    public relayDeploymentMode: string = 'diskful';
    public computeDeploymentMode: string = 'diskless';
    public relayRootfsTransfer: string = 'ethernet';
    public computeRootfsTransfer: string = 'infiniband';
    public relayOpaWaitSeconds: number = 30;
    public computeOpaWaitSeconds: number = 30;
    public bootMode: string = 'auto';
    public bootModePersistent: boolean = true;
    public sshBootstrap: string = 'enabled';
    public scriptBootstrap: string = 'enabled';
    public advancedConfigEnabled: boolean = true;
    public postDeployZabbixAgent: boolean = true;
    public postDeployZabbixProxy: boolean = true;
    public advancedEnvLoading: boolean = false;
    public advancedEnvSaving: boolean = false;
    public advancedEnvLoaded: boolean = false;
    public advancedEnvSelectedFile: string = 'relay_all';
    public advancedEnvFiles: any[] = [];
    public advancedEnvRows: any[] = [];
    public advancedEnvMessage: string = '';
    public deployActionMode: string = 'cluster';
    public deploymentStopping: boolean = false;
    public logTimeRange: string = 'all';
    public logTypeFilter: string = 'all';
    public logResultFilter: string = 'all';
    public logUserFilter: string = 'all';
    public logSearchText: string = '';
    public selectedLogId: string = '';
    public tabs: any[] = [
        { key: 'overview', label: 'Overview', icon: 'bx bx-server' },
        { key: 'deployment', label: 'Deployment', icon: 'bx bx-layer' },
        { key: 'nodes', label: 'Nodes', icon: 'bx bx-network-chart' },
        { key: 'monitoring', label: 'Monitoring', icon: 'bx bx-pulse' },
        { key: 'logs', label: 'Logs', icon: 'bx bx-file' },
    ];
    private routerSub: Subscription;
    private deploymentOptionsLoaded: boolean = false;
    private relayJobPoller: any = null;
    private readonly relayDefaultWindowGapSeconds: number = 3;
    private readonly relayDefaultWindowSize: number = 50;
    private readonly relayMaxWindowGapSeconds: number = 600;
    private readonly relayMaxWindowSize: number = 1000;
    private readonly opaWaitDefaultSeconds: number = 30;
    private readonly opaWaitMinSeconds: number = 5;
    private readonly opaWaitMaxSeconds: number = 600;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.syncRoute();
        await this.load();
        this.routerSub = this.router.events.subscribe(async (event) => {
            if (event instanceof NavigationEnd) {
                const previousId = this.id;
                const previousTab = this.tab;
                this.syncRoute();
                if (previousId !== this.id) {
                    await this.load();
                    return;
                }
                if (previousTab !== this.tab) {
                    await this.load();
                }
            }
        });
    }

    public ngOnDestroy() {
        if (this.routerSub) this.routerSub.unsubscribe();
        if (this.relayJobPoller) clearInterval(this.relayJobPoller);
    }

    private syncRoute() {
        this.id = Number(WizRoute.segment.id || this.id || 0);
        this.tab = this.normalizedTab(WizRoute.segment.tab || 'overview');
    }

    private normalizedTab(tab: any): string {
        const key = String(tab || 'overview').trim().toLowerCase() || 'overview';
        if (key === 'summary') return 'overview';
        return this.tabs.some((item: any) => item.key === key) ? key : 'overview';
    }

    public async load() {
        if (!this.id) {
            this.service.href('/kiera/cluster-deploy');
            return;
        }
        this.loading = true;
        this.errorMessage = '';
        this.deploymentOptionsLoaded = false;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get', { id: this.id, section: this.tab });
            if (code !== 200) {
                this.errorMessage = data?.message || '클러스터 정보를 불러오지 못했습니다.';
                this.item = null;
                return;
            }
            this.item = data?.item || null;
            this.nodes = Array.isArray(this.item?.nodes) ? this.item.nodes : [];
            this.normalizeNodesPage();
            this.relaySubnets = Array.isArray(this.item?.relay_subnets) ? this.item.relay_subnets : [];
            this.deployLogs = Array.isArray(this.item?.recent_deploys) ? this.item.recent_deploys : [];
            this.operationLogs = Array.isArray(this.item?.recent_operations) ? this.item.recent_operations : [];
            this.ensureDeploymentTargetSelection();
            this.relayCreatedId = String(this.item?.relay_group?.id || '');
            if (this.tab === 'deployment') void this.loadDeploymentOptions(true);
            if (this.isRelayDeployment() && this.relayCreatedId && ['deployment', 'nodes'].includes(this.tab)) {
                void this.refreshRelayOrchestrationJob(true);
            }
        } catch (error) {
            this.errorMessage = String(error || '클러스터 정보를 불러오지 못했습니다.');
            this.item = null;
        } finally {
            this.loading = false;
            this.refreshing = false;
            await this.service.render();
        }
    }

    public async refresh() {
        if (this.refreshing) return;
        this.moreOpen = false;
        this.refreshing = true;
        await this.load();
    }

    public selectTab(tab: string) {
        const key = this.normalizedTab(tab);
        this.moreOpen = false;
        this.deployMenuOpen = false;
        this.orchestrationErrorModalOpen = false;
        this.orchestrationErrorStep = null;
        this.orchestrationErrorRows = [];
        this.service.href(`/kiera/cluster-deploy/${this.id}/${key}`);
    }

    public openDeploymentForGroup(groupKey: any) {
        const key = String(groupKey || '').trim();
        this.deploymentScope = key ? 'group' : 'cluster';
        this.selectedDeploymentGroupKey = key;
        this.selectTab('deployment');
    }

    public toggleMore() {
        this.moreOpen = !this.moreOpen;
        this.service.render();
    }

    public toggleAdvancedDrawer() {
        this.advancedDrawerOpen = !this.advancedDrawerOpen;
        if (this.advancedDrawerOpen && !this.advancedEnvLoaded && !this.advancedEnvLoading) {
            this.loadAdvancedEnv(true);
        }
        this.service.render();
    }

    public openAdvancedDrawer(section: string = 'main') {
        this.advancedDrawerSection = String(section || 'main');
        this.advancedDrawerOpen = true;
        this.deployMenuOpen = false;
        if (!this.advancedEnvLoaded && !this.advancedEnvLoading) {
            this.loadAdvancedEnv(true);
        }
        this.service.render();
    }

    public closeAdvancedDrawer() {
        this.advancedDrawerOpen = false;
        this.service.render();
    }

    public toggleDeployMenu() {
        this.deployMenuOpen = !this.deployMenuOpen;
        this.service.render();
    }

    public deployActionOptions(): any[] {
        return [
            { key: 'cluster', label: '클러스터 전체 배포' },
            { key: 'selected', label: 'Deploy Selected' },
            { key: 'failed', label: 'Retry Failed' },
        ];
    }

    public onDeployActionModeChanged() {
        this.deployMenuOpen = false;
        this.relayPreflightReport = null;
        this.relayAllowOverride = false;
        this.deployMessage = '';
        this.relayMessage = '';
        this.service.render();
    }

    public showNodeSelectionCheckboxes(): boolean {
        return String(this.deployActionMode || 'cluster') === 'selected';
    }

    public deploymentActionCaption(): string {
        const action = String(this.deployActionMode || 'cluster');
        if (action === 'selected') return 'Deploy Selected: Nodes 탭에서 준비한 relay/compute 대상만 배포합니다.';
        if (action === 'failed') return 'Retry Failed: 실패 상태의 배포 대상을 재시도합니다.';
        if (this.isRelayDeployment()) return '클러스터 전체 배포: relay 배포 후 relay-ready가 되면 compute 배포가 이어집니다.';
        return '클러스터 전체 배포: 선택 범위의 compute 노드를 배포합니다.';
    }

    public deploymentActionBusy(): boolean {
        return !!this.deploying ||
            !!this.relayDeployStarting ||
            !!this.relayServerDeploying ||
            !!this.relayPreflightLoading ||
            !!this.deploymentStopping ||
            this.relayJobInProgress(this.relayOrchestrationJob) ||
            this.activeDeploymentOperationRows().length > 0;
    }

    public deployExecuteDisabled(): boolean {
        if (this.deploymentActionBusy()) return true;
        return String(this.deployActionMode || 'cluster') === 'selected' && this.selectedNodeCount() === 0;
    }

    private activeDeploymentOperationRows(): any[] {
        return (this.operationLogs || []).filter((row: any) => {
            const status = this.normalizedStatus(row?.status);
            if (!['pending', 'running', 'deploying', 'in_progress', 'in-progress', 'queued'].includes(status)) return false;
            if (String(row?.source || '') !== 'operation_task') return false;
            const category = String(row?.category || '').toLowerCase();
            const probe = `${row?.event || ''} ${row?.kind || ''} ${row?.related_id || ''}`.toLowerCase();
            return category === 'deployment' || ['deploy', 'relay', 'pxe', 'rootfs', 'bootstrap'].some((token: string) => probe.includes(token));
        });
    }

    public deploymentStopAvailable(): boolean {
        return this.relayJobInProgress(this.relayOrchestrationJob) || this.activeDeploymentOperationRows().length > 0;
    }

    public deploymentStopDisabled(): boolean {
        return this.deploymentStopping || !this.deploymentStopAvailable();
    }

    public async executeSelectedDeployAction() {
        if (this.deployExecuteDisabled()) return;
        await this.deployAction(this.deployActionMode || 'cluster');
    }

    public async stopDeployment() {
        if (this.deploymentStopDisabled()) return;
        if (!confirm('진행 중인 클러스터 배포를 정지하시겠습니까?')) return;

        this.deploymentStopping = true;
        const messages: string[] = [];
        const errors: string[] = [];
        await this.service.render();

        try {
            if (this.isRelayDeployment() && this.relayJobInProgress(this.relayOrchestrationJob)) {
                const relayResult = await this.relayApi('orchestration_stop', {
                    job_id: this.relayOrchestrationJobId,
                    group_id: this.relayCreatedId,
                });
                if (relayResult.code === 200) {
                    if (relayResult.data?.job) this.syncRelayOrchestrationJob(relayResult.data.job);
                    messages.push(relayResult.data?.message || 'Relay orchestration 정지를 요청했습니다.');
                    if (this.relayJobPoller) {
                        clearInterval(this.relayJobPoller);
                        this.relayJobPoller = null;
                    }
                } else {
                    errors.push(relayResult.data?.message || 'Relay orchestration 정지에 실패했습니다.');
                }
            }

            const operationResult = await this.clusterDeployApi('deployment_stop', { id: this.id });
            if (operationResult.code === 200) {
                messages.push(operationResult.data?.message || '배포 작업 정지를 요청했습니다.');
            } else {
                errors.push(operationResult.data?.message || '배포 작업 정지에 실패했습니다.');
            }

            await this.load();
            const message = [...messages, ...errors].filter(Boolean).join(' ')
                || '정지할 활성 배포 작업이 없습니다.';
            if (this.isRelayDeployment()) this.relayMessage = message;
            else this.deployMessage = message;
        } finally {
            this.deploymentStopping = false;
            await this.service.render();
        }
    }

    public openClusterManagement(tab: string = 'summary') {
        this.moreOpen = false;
        this.service.href(`/kiera/clusters/${this.id}/${tab}`);
    }

    public openDeploymentWorkspace() {
        this.openClusterManagement(this.isRelayDeployment() ? 'relay' : 'deploy');
    }

    public config(): any {
        const raw = this.item?.config || {};
        if (raw && typeof raw === 'object' && !Array.isArray(raw)) return raw;
        try {
            const parsed = JSON.parse(String(raw || '{}'));
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    private nestedValue(source: any, path: string): any {
        let current = source || {};
        for (const part of String(path || '').split('.')) {
            if (!part || current === null || current === undefined || typeof current !== 'object') return '';
            current = current[part];
        }
        return current;
    }

    private configValue(paths: string[], fallback: any = ''): any {
        const config = this.config();
        for (const path of paths || []) {
            const value = this.nestedValue(config, path);
            if (value !== undefined && value !== null && String(value).trim() !== '') return value;
        }
        return fallback;
    }

    public formatNumber(value: any): string {
        const numberValue = Number(value || 0);
        return Number.isFinite(numberValue) ? numberValue.toLocaleString() : '0';
    }

    public datePart(value: any): string {
        const text = String(value || '').trim();
        if (!text) return '-';
        return text.split(/[T ]/)[0] || text;
    }

    public timePart(value: any): string {
        const text = String(value || '').trim();
        if (!text) return '';
        const time = text.includes('T') ? text.split('T')[1] : text.split(' ')[1];
        return String(time || '').replace(/\.\d+$/, '').replace(/Z$/, '');
    }

    public formatDateTime(value: any): string {
        const date = this.datePart(value);
        const time = this.timePart(value);
        return time ? `${date} ${time}` : date;
    }

    public creatorLabel(): string {
        return String(this.item?.creator || this.configValue(['creator', 'created_by', 'author'], 'Admin') || 'Admin');
    }

    public statusLabel(): string {
        const status = String(this.item?.status || '').trim().toLowerCase();
        if (status === 'active') return '활성';
        if (status === 'inactive') return '비활성';
        if (status === 'maintenance') return '점검';
        return status ? status.toUpperCase() : '-';
    }

    public statusBadgeClass(): string {
        const status = String(this.item?.status || '').trim().toLowerCase();
        if (status === 'active') return 'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200';
        if (status === 'maintenance') return 'bg-amber-100 text-amber-700 ring-1 ring-amber-200';
        return 'bg-zinc-100 text-zinc-600 ring-1 ring-zinc-200';
    }

    public clusterCreationType(): string {
        const configured = String(this.item?.cluster_type || this.configValue(['creation_mode', 'create_mode'], '') || '').trim().toLowerCase();
        if (configured === 'template' || configured === 'template_based') return 'template';
        if (configured === 'manual') return 'manual';
        if (this.configValue(['template_file', 'template.file', 'template_preview.file.name'], '')) return 'template';
        return 'manual';
    }

    public clusterCreationLabel(): string {
        return this.clusterCreationType() === 'template' ? 'Template' : 'Manual';
    }

    public clusterCreationCaption(): string {
        return this.clusterCreationType() === 'template' ? '템플릿 기반 생성' : '수동 구성 생성';
    }

    public deploymentType(): string {
        const configured = String(this.item?.deployment_type || this.configValue(['provisioning_mode', 'deployment_type', 'deployment.mode'], '') || '').trim().toLowerCase();
        if (configured.includes('relay') || configured.includes('중계') || configured.includes('릴레이')) return 'relay';
        if (configured.includes('direct') || configured.includes('직접')) return 'direct';
        return this.relayNodes().length > 0 ? 'relay' : 'direct';
    }

    public isRelayDeployment(): boolean {
        return this.deploymentType() === 'relay';
    }

    public deploymentTypeLabel(): string {
        return this.isRelayDeployment() ? 'Relay' : 'Direct';
    }

    public deploymentTypeCaption(): string {
        return this.isRelayDeployment() ? '중계 서버 방식' : '단일 서버 직접 배포';
    }

    public bootModeOptions(): any[] {
        return [
            { value: 'auto', label: 'Auto', desc: '각 노드의 현재 Boot Type을 유지한 상태로 배포' },
            { value: 'uefi', label: 'UEFI', desc: 'UEFI 부트 플래그로 배포' },
            { value: 'legacy', label: 'Legacy', desc: 'Legacy 부트 플래그로 배포' },
        ];
    }

    public normalizedBootMode(value: any = this.bootMode): string {
        const normalized = String(value || '').trim().toLowerCase();
        if (normalized === 'uefi' || normalized === 'efi') return 'uefi';
        if (normalized === 'legacy' || normalized === 'bios') return 'legacy';
        return 'auto';
    }

    public requestedBootType(): string {
        const mode = this.normalizedBootMode();
        if (mode === 'uefi') return 'UEFI';
        if (mode === 'legacy') return 'Legacy';
        return '';
    }

    public effectiveBootTypeForNode(node: any): string {
        const requested = this.requestedBootType();
        if (requested) return requested;
        const stored = this.normalizedBootMode(node?.boot_type || node?.boot_mode || '');
        if (stored === 'uefi') return 'UEFI';
        if (stored === 'legacy') return 'Legacy';
        return '';
    }

    public bootModeLabel(value: any = this.bootMode): string {
        const mode = this.normalizedBootMode(value);
        if (mode === 'uefi') return 'UEFI';
        if (mode === 'legacy') return 'Legacy';
        return 'Auto';
    }

    public bootModePersistence(): string {
        if (this.normalizedBootMode() === 'auto') return 'one_time';
        return this.bootModePersistent ? 'persistent' : 'one_time';
    }

    public bootModePersistenceDisabled(): boolean {
        return this.normalizedBootMode() === 'auto';
    }

    public bootModePersistenceLabel(): string {
        return this.bootModePersistence() === 'persistent' ? '배포 후 유지' : '사용 안 함';
    }

    public bootModeCaption(): string {
        const requested = this.requestedBootType();
        if (requested && this.bootModePersistence() === 'persistent') {
            return `${requested} 일회성 PXE로 배포한 뒤 Diskful은 로컬 디스크, Diskless는 PXE를 Persistent 부팅 오버라이드로 유지합니다. BIOS 설정은 변경하지 않습니다.`;
        }
        if (requested) {
            return `${requested} 일회성 PXE 부팅으로만 배포합니다. Diskful 설치 후 로컬 디스크 부팅도 일회성으로 설정하며 Persistent 오버라이드는 남기지 않습니다.`;
        }
        return 'Auto는 각 대상 노드의 현재 Boot Type을 강제 전환하지 않고 그대로 사용해 배포합니다.';
    }

    public onBootModeChanged() {
        this.bootMode = this.normalizedBootMode();
        if (this.bootMode === 'auto') this.bootModePersistent = false;
        this.onBootModeOptionChanged();
    }

    public onBootModePersistenceChanged() {
        if (this.bootModePersistenceDisabled()) this.bootModePersistent = false;
        this.onBootModeOptionChanged();
    }

    private onBootModeOptionChanged() {
        this.relayPreflightReport = null;
        this.relayAllowOverride = false;
        this.deployMessage = '';
        this.relayMessage = '';
        this.service.render();
    }

    public isRelayNode(node: any): boolean {
        return ['authority', 'member'].includes(String(node?.cluster_relay_role || '').trim().toLowerCase());
    }

    public relayNodes(): any[] {
        return (this.nodes || []).filter((node: any) => this.isRelayNode(node));
    }

    public activeRelayNodes(): any[] {
        return this.relayNodes().filter((node: any) => !node.cluster_relay_excluded);
    }

    public computeNodes(): any[] {
        if (!this.isRelayDeployment()) return this.nodes || [];
        return (this.nodes || []).filter((node: any) => !this.isRelayNode(node) && !node.cluster_relay_excluded && !node.cluster_relay_unassigned);
    }

    public mainServer(): any {
        return (this.nodes || []).find((node: any) => Number(node?.is_cluster_head || 0) === 1) || (this.nodes || [])[0] || null;
    }

    public mainServerCount(): number {
        return this.mainServer() ? 1 : 0;
    }

    private normalizedStatus(value: any): string {
        return String(value || '').trim().toLowerCase();
    }

    private nodeReadyIdle(node: any): boolean {
        const status = this.normalizedStatus(node?.status);
        const deployStatus = this.normalizedStatus(node?.deploy_status);
        const imageId = String(node?.image_id ?? '').trim();
        return status === 'ready'
            && ['', 'none', 'ready', 'idle'].includes(deployStatus)
            && (!imageId || imageId === '0' || imageId.toLowerCase() === 'null');
    }

    public nodeDeployBucket(node: any): string {
        if (this.nodeReadyIdle(node)) return 'pending';
        const clusterStatus = this.normalizedStatus(node?.cluster_deploy_status);
        const clusterLastDeploy = String(node?.cluster_last_deploy || '').trim();
        if (!clusterStatus && !clusterLastDeploy) return 'pending';
        if (clusterStatus.includes('fail') || clusterStatus.includes('error') || clusterStatus.includes('cancel')) return 'failed';
        if (['pending', 'running', 'deploying', 'in_progress', 'in-progress', 'queued'].includes(clusterStatus)) return 'in_progress';
        if (clusterStatus === 'relay-ready' || clusterStatus === 'ready') return 'deployed';
        if (['completed', 'deployed', 'done', 'success', 'succeeded'].includes(clusterStatus) || clusterLastDeploy) return 'deployed';
        return 'pending';
    }

    public deployStats(nodes: any[] = this.computeNodes()): any {
        const stats = { total: 0, deployed: 0, in_progress: 0, pending: 0, failed: 0 };
        for (const node of nodes || []) {
            stats.total++;
            const bucket = this.nodeDeployBucket(node);
            if (bucket === 'deployed') stats.deployed++;
            else if (bucket === 'in_progress') stats.in_progress++;
            else if (bucket === 'failed') stats.failed++;
            else stats.pending++;
        }
        return stats;
    }

    public progressPercent(stats: any = this.deployStats()): number {
        const total = Number(stats?.total || 0);
        if (total <= 0) return 0;
        return Math.round((Number(stats?.deployed || 0) / total) * 100);
    }

    public deploymentStatusKey(stats: any = this.deployStats()): string {
        const total = Number(stats?.total || 0);
        if (total <= 0) return 'pending';
        if (Number(stats?.in_progress || 0) > 0) return 'deploying';
        if (Number(stats?.failed || 0) > 0) return 'failed';
        if (Number(stats?.deployed || 0) >= total) return 'completed';
        if (Number(stats?.deployed || 0) > 0) return 'partial';
        return 'pending';
    }

    public deploymentStatusLabel(stats: any = this.deployStats()): string {
        const key = this.deploymentStatusKey(stats);
        if (key === 'completed') return '배포 완료';
        if (key === 'deploying') return '배포 중';
        if (key === 'partial') return '일부 배포';
        if (key === 'failed') return '배포 실패';
        return '배포 준비';
    }

    public deploymentStatusBadgeClass(stats: any = this.deployStats()): string {
        const key = this.deploymentStatusKey(stats);
        if (key === 'completed') return 'bg-emerald-100 text-emerald-700';
        if (key === 'deploying') return 'bg-blue-100 text-blue-700';
        if (key === 'partial') return 'bg-orange-100 text-orange-700';
        if (key === 'failed') return 'bg-rose-100 text-rose-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public deploymentStatusDotClass(key: string): string {
        if (key === 'completed' || key === 'deployed') return 'bg-emerald-500';
        if (key === 'deploying' || key === 'in_progress') return 'bg-blue-600';
        if (key === 'partial') return 'bg-orange-500';
        if (key === 'failed') return 'bg-rose-600';
        return 'bg-slate-500';
    }

    public progressBarClass(stats: any = this.deployStats()): string {
        const key = this.deploymentStatusKey(stats);
        if (key === 'completed') return 'bg-emerald-500';
        if (key === 'failed') return 'bg-rose-600';
        if (key === 'partial') return 'bg-orange-500';
        return 'bg-blue-600';
    }

    private maxLastDeploy(nodes: any[]): string {
        let latest = '';
        for (const node of nodes || []) {
            const value = String(node?.cluster_last_deploy || '').trim();
            if (value && (!latest || value > latest)) latest = value;
        }
        return latest;
    }

    public nodeDeployTime(node: any): string {
        return String(node?.cluster_deploy_completed || node?.cluster_last_deploy || node?.cluster_deploy_started || '').trim();
    }

    public latestDeployAt(): string {
        const latest = String(this.item?.latest_deploy || '').trim() || this.maxLastDeploy(this.nodes);
        return latest;
    }

    public recentDeployStateLabel(): string {
        const key = this.deploymentStatusKey(this.deployStats());
        if (key === 'completed') return '완료';
        if (key === 'failed') return '실패';
        if (key === 'pending') return '대기';
        return '진행 중';
    }

    public overviewCards(): any[] {
        const stats = this.deployStats();
        const cards: any[] = [
            {
                label: '클러스터 생성 방식',
                value: this.clusterCreationLabel(),
                sub: this.clusterCreationCaption(),
                icon: 'bx bx-cloud-upload',
                color: 'violet',
            },
            {
                label: '배포 구조',
                value: this.deploymentTypeLabel(),
                sub: this.deploymentTypeCaption(),
                icon: 'bx bx-git-branch',
                color: 'emerald',
            },
        ];

        if (this.isRelayDeployment()) {
            cards.push(
                {
                    label: '릴레이 그룹',
                    value: this.formatNumber(this.relayGroupRows().length),
                    unit: '개',
                    sub: '그룹',
                    icon: 'bx bx-server',
                    color: 'blue',
                },
                {
                    label: '릴레이 서버',
                    value: this.formatNumber(this.activeRelayNodes().length),
                    unit: '대',
                    sub: `${this.formatNumber(this.relayReadyCount())} 준비 완료`,
                    icon: 'bx bx-server',
                    color: 'violet',
                }
            );
        } else {
            cards.push({
                label: '메인 서버',
                value: this.formatNumber(this.mainServerCount()),
                unit: '대',
                sub: this.mainServer()?.name || '직접 배포 서버 수',
                icon: 'bx bx-server',
                color: 'blue',
            });
        }

        cards.push(
            {
                label: '계산 노드',
                value: this.formatNumber(this.computeNodes().length),
                unit: '대',
                sub: `${this.formatNumber(stats.deployed)} 배포 완료  ${this.formatNumber(stats.in_progress)} 배포 중`,
                icon: 'bx bx-chip',
                color: 'emerald',
            },
            {
                label: '배포 상태',
                value: this.deploymentStatusLabel(stats),
                sub: `${this.formatNumber(stats.deployed)} / ${this.formatNumber(stats.total)} 노드 처리 중`,
                progress: this.progressPercent(stats),
                icon: 'bx bx-pulse',
                color: 'blue',
            },
            {
                label: '최근 배포',
                value: this.recentDeployStateLabel(),
                sub: this.latestDeployAt() ? `시작: ${this.formatDateTime(this.latestDeployAt())}` : '-',
                icon: 'bx bx-rocket',
                color: 'violet',
            }
        );
        return cards;
    }

    public cardIconClass(card: any): string {
        if (card?.color === 'emerald') return 'bg-emerald-100 text-emerald-600';
        if (card?.color === 'blue') return 'bg-blue-100 text-blue-600';
        if (card?.color === 'violet') return 'bg-violet-100 text-violet-600';
        return 'bg-slate-100 text-slate-600';
    }

    public clusterInfoRows(): any[] {
        return [
            { label: '클러스터 ID', value: this.item?.cluster_uid || this.item?.id || '-' },
            { label: '그룹', value: this.item?.group_name || '-' },
            { label: '설명', value: this.item?.description || '-' },
            { label: '생성일', value: this.formatDateTime(this.item?.created) },
            { label: '최종 수정일', value: this.formatDateTime(this.item?.updated) },
        ];
    }

    private defaultRelayGroupKey(node: any): string {
        const subnetId = String(node?.dhcp_domain_subnet_id || '').trim();
        if (subnetId) return `id:${subnetId}`;
        const domainKey = String(node?.dhcp_domain_key || '').trim();
        if (domainKey) return domainKey;
        const vlanId = String(node?.dhcp_domain_vlan_id || '').trim();
        if (vlanId && vlanId !== '0') return `vlan:${vlanId}`;
        const cidr = String(node?.dhcp_domain_cidr || '').trim();
        if (cidr) return `cidr:${cidr}`;
        return 'default';
    }

    public groupKey(node: any): string {
        return String(node?.cluster_relay_dhcp_group_key || '').trim() || this.defaultRelayGroupKey(node);
    }

    public subnetForKey(key: any): any {
        const normalized = String(key || '').trim();
        return (this.relaySubnets || []).find((subnet: any) => String(subnet?.key || '').trim() === normalized) || null;
    }

    private relayDomainMetadata(): any {
        const selection = this.item?.relay_group?.node_selection;
        const metadata = selection && typeof selection === 'object' ? selection.relay_domain_metadata : {};
        return metadata && typeof metadata === 'object' ? metadata : {};
    }

    private relayMetadataForKey(key: any): any {
        const metadata = this.relayDomainMetadata()[String(key || '').trim()];
        return metadata && typeof metadata === 'object' ? metadata : {};
    }

    private relayNonEmpty(...values: any[]): any {
        for (const value of values) {
            if (value !== undefined && value !== null && String(value).trim() !== '') return value;
        }
        return '';
    }

    private relayVlanIdFromKey(key: any): string {
        const normalized = String(key || '').trim();
        if (!normalized.startsWith('vlan:')) return '';
        return normalized.split(':').slice(1).join(':');
    }

    private relayNetworkInfoForKey(key: any): any {
        const groupKey = String(key || '').trim();
        const subnet = this.subnetForKey(groupKey) || {};
        const metadata = this.relayMetadataForKey(groupKey);
        const dhcpStart = this.relayNonEmpty(metadata.dhcp_start, metadata.dhcp_pool_start, subnet.dhcp_start, subnet.dhcp_pool_start);
        const dhcpEnd = this.relayNonEmpty(metadata.dhcp_end, metadata.dhcp_pool_end, subnet.dhcp_end, subnet.dhcp_pool_end);
        return {
            key: groupKey,
            label: this.relayNonEmpty(metadata.label, subnet.label, groupKey),
            name: this.relayNonEmpty(metadata.subnet_name, metadata.network_name, subnet.name),
            vlan_id: this.relayNonEmpty(metadata.vlan_id, subnet.vlan_id, this.relayVlanIdFromKey(groupKey)),
            cidr: this.relayNonEmpty(metadata.cidr, subnet.cidr),
            gateway: this.relayNonEmpty(metadata.gateway, subnet.gateway, subnet.gateway_ip),
            dhcp_pool: this.relayNonEmpty(metadata.dhcp_pool, subnet.dhcp_pool, dhcpStart && dhcpEnd ? `${dhcpStart} ~ ${dhcpEnd}` : ''),
        };
    }

    public relayGroupName(key: any, index: number): string {
        const metadata = this.relayMetadataForKey(key);
        const network = this.relayNetworkInfoForKey(key);
        if (metadata?.name) return metadata.name;
        if (network.name) return network.name;
        if (network.label && !String(network.label).startsWith('VLAN')) return network.label;
        if (network.vlan_id) return `RG-${network.vlan_id}`;
        return `RG${String(index + 1).padStart(2, '0')}`;
    }

    public relayReadyCount(): number {
        return this.activeRelayNodes().filter((node: any) => {
            const status = `${this.normalizedStatus(node?.status)} ${this.normalizedStatus(node?.deploy_status)}`;
            return status.includes('ready') || status.includes('deployed') || status.includes('active') || !!String(node?.last_deploy || '').trim();
        }).length;
    }

    public relayGroupRows(): any[] {
        const relays = this.activeRelayNodes();
        const computes = this.computeNodes();
        const keys: string[] = [];
        const addKey = (key: any) => {
            const value = String(key || 'default').trim() || 'default';
            if (!keys.includes(value)) keys.push(value);
        };
        Object.keys(this.relayDomainMetadata()).forEach((key: string) => addKey(key));
        relays.forEach((node: any) => addKey(this.groupKey(node)));
        if (keys.length === 0 && relays.length > 0) keys.push('default');

        return keys.map((key: string, index: number) => {
            const network = this.relayNetworkInfoForKey(key);
            const relayRows = relays.filter((node: any) => this.groupKey(node) === key);
            const relayIds = new Set(relayRows.map((node: any) => String(node.id)));
            const computeRows = computes.filter((node: any) => relayIds.has(String(node.cluster_relay_id || '')));
            const stats = this.deployStats(computeRows);
            return {
                key,
                groupKey: key,
                name: this.relayGroupName(key, index),
                subnet_name: network.name || '',
                vlan_id: network.vlan_id || '',
                cidr: network.cidr || '',
                gateway: network.gateway || '',
                dhcp_pool: network.dhcp_pool || '',
                authority: relayRows.filter((node: any) => String(node.cluster_relay_role || '').toLowerCase() === 'authority').length,
                members: relayRows.filter((node: any) => String(node.cluster_relay_role || '').toLowerCase() === 'member').length,
                relay_server_count: relayRows.length,
                compute_count: computeRows.length,
                stats,
                progress: this.progressPercent(stats),
                status: this.deploymentStatusLabel(stats),
                statusClass: this.deploymentStatusBadgeClass(stats),
                last_deploy: this.maxLastDeploy(computeRows) || this.latestDeployAt(),
            };
        });
    }

    private nodeGroupKey(node: any): string {
        const groupId = String(node?.group_id || '').trim();
        return groupId ? `group:${groupId}` : 'default';
    }

    public directGroupRows(): any[] {
        const nodes = this.computeNodes();
        const keys: string[] = [];
        const addKey = (key: string) => {
            if (!keys.includes(key)) keys.push(key);
        };
        nodes.forEach((node: any) => addKey(this.nodeGroupKey(node)));
        return keys.map((key: string) => {
            const groupNodes = nodes.filter((node: any) => this.nodeGroupKey(node) === key);
            const groupId = key.startsWith('group:') ? key.replace('group:', '') : '';
            const stats = this.deployStats(groupNodes);
            return {
                key,
                name: groupId ? `Group ${groupId}` : 'Default Group',
                compute_count: groupNodes.length,
                stats,
                progress: this.progressPercent(stats),
                status: this.deploymentStatusLabel(stats),
                statusClass: this.deploymentStatusBadgeClass(stats),
                last_deploy: this.maxLastDeploy(groupNodes),
            };
        });
    }

    public deploymentGroupOptions(): any[] {
        if (this.isRelayDeployment()) {
            return this.relayGroupRows().map((row: any) => ({
                key: row.key,
                name: row.name,
                compute_count: row.compute_count,
                relay_server_count: row.relay_server_count,
                gateway: row.gateway,
                dhcp_pool: row.dhcp_pool,
            }));
        }
        return this.directGroupRows();
    }

    private ensureDeploymentTargetSelection() {
        const groups = this.deploymentGroupOptions();
        if (this.deploymentScope !== 'group') {
            this.deploymentScope = 'cluster';
            return;
        }
        if (groups.length === 0) {
            this.deploymentScope = 'cluster';
            this.selectedDeploymentGroupKey = '';
            return;
        }
        const exists = groups.some((row: any) => String(row.key) === String(this.selectedDeploymentGroupKey));
        if (!exists) this.selectedDeploymentGroupKey = groups[0].key;
    }

    public onDeploymentScopeChanged(scope: string) {
        this.deploymentScope = scope === 'group' ? 'group' : 'cluster';
        this.ensureDeploymentTargetSelection();
        this.relayPreflightReport = null;
        this.relayAllowOverride = false;
        this.deployMessage = '';
        this.relayMessage = '';
        this.service.render();
    }

    public onDeploymentGroupChanged() {
        this.ensureDeploymentTargetSelection();
        this.relayPreflightReport = null;
        this.relayAllowOverride = false;
        this.deployMessage = '';
        this.relayMessage = '';
        this.service.render();
    }

    public selectedDeploymentGroup(): any {
        if (this.deploymentScope !== 'group') return null;
        return this.deploymentGroupOptions().find((row: any) => String(row.key) === String(this.selectedDeploymentGroupKey)) || null;
    }

    public deploymentTargetLabel(): string {
        const group = this.selectedDeploymentGroup();
        if (!group) return '전체 클러스터';
        return group.name || group.key || '선택 그룹';
    }

    public relayServersForGroup(key: any): any[] {
        const groupKey = String(key || '').trim();
        const relays = this.activeRelayNodes();
        if (!groupKey) return relays;
        return relays.filter((node: any) => this.groupKey(node) === groupKey);
    }

    public computeNodesForRelayGroup(key: any): any[] {
        const groupKey = String(key || '').trim();
        const computes = this.computeNodes();
        if (!groupKey) return computes;
        const relayRows = this.relayServersForGroup(groupKey);
        const relayIds = new Set(relayRows.map((node: any) => String(node.id)));
        return computes.filter((node: any) => relayIds.has(String(node.cluster_relay_id || '')));
    }

    public targetRelayServers(): any[] {
        if (!this.isRelayDeployment()) return [];
        if (this.deploymentScope !== 'group') return this.activeRelayNodes();
        return this.relayServersForGroup(this.selectedDeploymentGroupKey);
    }

    public targetComputeNodes(): any[] {
        if (this.isRelayDeployment()) {
            if (this.deploymentScope !== 'group') return this.computeNodes();
            return this.computeNodesForRelayGroup(this.selectedDeploymentGroupKey);
        }
        if (this.deploymentScope !== 'group') return this.computeNodes();
        return this.computeNodes().filter((node: any) => this.nodeGroupKey(node) === this.selectedDeploymentGroupKey);
    }

    public targetDeployStats(): any {
        return this.deployStats(this.targetComputeNodes());
    }

    public deploymentMetricCards(): any[] {
        const allNodes = this.isRelayDeployment()
            ? [...this.targetRelayServers(), ...this.targetComputeNodes()]
            : this.targetComputeNodes();
        const relayStats = this.deployStats(this.targetRelayServers());
        const computeStats = this.targetDeployStats();
        return [
            {
                key: 'total',
                label: '전체 노드',
                value: this.formatNumber(allNodes.length),
                relay: this.formatNumber(this.isRelayDeployment() ? this.targetRelayServers().length : this.mainServerCount()),
                compute: this.formatNumber(this.targetComputeNodes().length),
                icon: 'bx bx-server',
                color: 'indigo',
            },
            {
                key: 'success',
                label: '성공',
                value: this.formatNumber(computeStats.deployed + (this.isRelayDeployment() ? relayStats.deployed : 0)),
                relay: this.formatNumber(this.isRelayDeployment() ? relayStats.deployed : 0),
                compute: this.formatNumber(computeStats.deployed),
                icon: 'bx bx-check',
                color: 'emerald',
            },
            {
                key: 'deploying',
                label: '배포 중',
                value: this.formatNumber(computeStats.in_progress + (this.isRelayDeployment() ? relayStats.in_progress : 0)),
                relay: this.formatNumber(this.isRelayDeployment() ? relayStats.in_progress : 0),
                compute: this.formatNumber(computeStats.in_progress),
                icon: 'bx bx-loader-circle',
                color: 'blue',
            },
            {
                key: 'failed',
                label: '실패',
                value: this.formatNumber(computeStats.failed + (this.isRelayDeployment() ? relayStats.failed : 0)),
                relay: this.formatNumber(this.isRelayDeployment() ? relayStats.failed : 0),
                compute: this.formatNumber(computeStats.failed),
                icon: 'bx bx-x',
                color: 'rose',
            },
            {
                key: 'pending',
                label: '대기',
                value: this.formatNumber(computeStats.pending + (this.isRelayDeployment() ? relayStats.pending : 0)),
                relay: this.formatNumber(this.isRelayDeployment() ? relayStats.pending : 0),
                compute: this.formatNumber(computeStats.pending),
                icon: 'bx bx-time-five',
                color: 'slate',
            },
        ];
    }

    public deploymentMetricRows(card: any): any[] {
        if (this.isRelayDeployment()) {
            return [
                { label: 'Relay', value: card?.relay ?? '0' },
                { label: 'Compute', value: card?.compute ?? '0' },
            ];
        }
        return [
            { label: 'Main', value: this.formatNumber(this.mainServerCount()) },
            { label: 'Compute', value: card?.compute ?? '0' },
        ];
    }

    public directDeploymentPathRows(): any[] {
        const server = this.mainServer() || {};
        return [
            {
                label: '배포 경로',
                value: 'Main Server -> Compute Nodes',
                sub: '릴레이 서버 없이 메인 서버에서 직접 PXE/부트스트랩을 실행합니다.',
            },
            {
                label: '메인 서버',
                value: server.name || '-',
                sub: server.ip_address || server.bmc_ip || '-',
            },
            {
                label: '계산 노드',
                value: `${this.formatNumber(this.targetComputeNodes().length)} nodes`,
                sub: this.deploymentTargetLabel(),
            },
        ];
    }

    public deploymentNodesTitle(): string {
        return this.isRelayDeployment()
            ? '5. Deployment Control & Progress'
            : '4. Deployment Control & Progress';
    }

    public metricIconClass(card: any): string {
        if (card?.color === 'emerald') return 'bg-emerald-100 text-emerald-600';
        if (card?.color === 'blue') return 'bg-blue-100 text-blue-600';
        if (card?.color === 'rose') return 'bg-rose-100 text-rose-600';
        if (card?.color === 'indigo') return 'bg-indigo-100 text-indigo-600';
        return 'bg-slate-100 text-slate-600';
    }

    public targetNodeSummaryCards(): any[] {
        const stats = this.targetDeployStats();
        const cards = [
            { label: '대상 범위', value: this.deploymentTargetLabel(), sub: this.deploymentScope === 'group' ? '그룹 단위 배포' : '클러스터 전체 배포' },
            { label: '계산 노드', value: this.formatNumber(stats.total), sub: `${this.progressPercent(stats)}% 완료` },
            { label: '배포 대기', value: this.formatNumber(stats.pending), sub: '아직 배포되지 않은 노드' },
            { label: '실패', value: this.formatNumber(stats.failed), sub: '재시도 확인 대상' },
        ];
        if (this.isRelayDeployment()) {
            cards.splice(1, 0, { label: 'Relay Server', value: this.formatNumber(this.targetRelayServers().length), sub: '선택 범위의 relay 서버' });
        }
        return cards;
    }

    public deploymentModeLabel(value: any): string {
        return String(value || '').toLowerCase() === 'diskless' ? 'Diskless' : 'Diskful';
    }

    private normalizedDeploymentMode(value: any): string {
        return String(value || '').trim().toLowerCase() === 'diskless' ? 'diskless' : 'diskful';
    }

    public imageIsDiskless(image: any): boolean {
        if (!image) return false;
        if (image.is_diskless === true || image.diskless === true) return true;
        const disklessId = Number(image.disk_less_linux_id || image.diskless_linux_id || image.diskless_id || 0);
        if (Number.isFinite(disklessId) && disklessId > 0) return true;
        const type = String(image.type ?? image.image_type ?? '').toLowerCase();
        if (type === '10' || type.includes('diskless')) return true;
        const text = `${image.name || ''} ${image.title || ''} ${image.os || ''}`.toLowerCase();
        return text.includes('diskless') || text.includes('disk-less');
    }

    public imagesForMode(rows: any[], mode: any): any[] {
        const diskless = this.normalizedDeploymentMode(mode) === 'diskless';
        return (rows || []).filter((image: any) => this.imageIsDiskless(image) === diskless);
    }

    public relayModeImages(): any[] {
        return this.imagesForMode(this.relayImages, this.relayDeploymentMode);
    }

    public directModeImages(): any[] {
        return this.imagesForMode(this.images, this.relayDeploymentMode);
    }

    public computeModeRelayImages(): any[] {
        return this.imagesForMode(this.relayImages, this.computeDeploymentMode);
    }

    public computeModeImages(): any[] {
        return this.imagesForMode(this.images, this.computeDeploymentMode);
    }

    private firstImageId(rows: any[]): string {
        const row = (rows || [])[0];
        return row?.id ? String(row.id) : '';
    }

    private imageIdExists(rows: any[], imageId: any): boolean {
        const normalized = String(imageId || '');
        return !!normalized && (rows || []).some((image: any) => String(image?.id || '') === normalized);
    }

    private ensureDeploymentImageSelections() {
        if (this.isRelayDeployment()) {
            const relayRows = this.relayModeImages();
            const computeRows = this.computeModeRelayImages();
            if (!this.imageIdExists(relayRows, this.relayForm.relay_image_id)) {
                this.relayForm.relay_image_id = this.firstImageId(relayRows);
            }
            if (!this.imageIdExists(computeRows, this.relayForm.computing_image_id)) {
                this.relayForm.computing_image_id = this.firstImageId(computeRows);
            }
            return;
        }

        const directRows = this.computeModeImages().length > 0 ? this.computeModeImages() : this.directModeImages();
        if (!this.imageIdExists(directRows, this.deployForm.image_id)) {
            this.deployForm.image_id = this.firstImageId(directRows);
        }
    }

    public onRelayDeploymentModeChanged() {
        this.relayDeploymentMode = this.normalizedDeploymentMode(this.relayDeploymentMode);
        this.ensureDeploymentImageSelections();
        this.onRelayDeployOptionChanged();
    }

    public onComputeDeploymentModeChanged() {
        this.computeDeploymentMode = this.normalizedDeploymentMode(this.computeDeploymentMode);
        this.ensureDeploymentImageSelections();
        if (this.isRelayDeployment()) this.onRelayDeployOptionChanged();
        else this.onDeployImageChanged();
    }

    public transferLabel(value: any): string {
        return String(value || '').toLowerCase() === 'infiniband' ? 'OPA / InfiniBand' : 'Ethernet';
    }

    public nodeStatusFilterItems(): any[] {
        return [
            { key: 'all', label: '전체', className: 'bg-indigo-600' },
            { key: 'deployed', label: '성공', className: 'bg-emerald-500' },
            { key: 'in_progress', label: '배포 중', className: 'bg-blue-600' },
            { key: 'failed', label: '실패', className: 'bg-rose-600' },
            { key: 'pending', label: '대기', className: 'bg-slate-500' },
        ];
    }

    public toggleNodeStatusFilter(key: string) {
        const normalized = String(key || 'all');
        if (normalized === 'all') {
            this.nodeStatusFilters = { all: true, deployed: false, in_progress: false, failed: false, pending: false };
        } else {
            this.nodeStatusFilters.all = false;
            this.nodeStatusFilters[normalized] = !this.nodeStatusFilters[normalized];
            const enabled = ['deployed', 'in_progress', 'failed', 'pending'].some((item: string) => !!this.nodeStatusFilters[item]);
            if (!enabled) this.nodeStatusFilters.all = true;
        }
        this.service.render();
    }

    public nodeStatusFilterEnabled(key: string): boolean {
        return !!this.nodeStatusFilters[String(key || 'all')];
    }

    private nodeMatchesStatusFilter(node: any): boolean {
        if (this.nodeStatusFilters.all) return true;
        return !!this.nodeStatusFilters[this.nodeDeployBucket(node)];
    }

    private nodeMatchesTypeFilter(node: any): boolean {
        const filter = String(this.nodeTypeFilter || 'all').toLowerCase();
        if (filter === 'relay') return String(node?.tree_role || '') === 'relay';
        if (filter === 'compute') return String(node?.tree_role || '') === 'compute';
        return true;
    }

    private nodeMatchesSearch(node: any): boolean {
        const keyword = String(this.nodeSearchText || '').trim().toLowerCase();
        if (!keyword) return true;
        const haystack = [
            node?.name,
            node?.ip_address,
            node?.bmc_ip,
            node?.mac_address,
            node?.bmc_mac,
            node?.dhcp_domain_label,
        ].map((value: any) => String(value || '').toLowerCase()).join(' ');
        return haystack.includes(keyword);
    }

    private orchestrationNodeMap(role: string): any {
        const rows = role === 'relay'
            ? (this.relayOrchestrationJob?.relay_servers || [])
            : (this.relayOrchestrationJob?.computing_nodes || []);
        const map: any = {};
        for (const row of rows || []) {
            const keys = [row?.node_id, row?.id, row?.group_server_id].map((value: any) => String(value || '').trim()).filter((value: string) => !!value);
            for (const key of keys) map[key] = row;
        }
        return map;
    }

    private mergeOrchestrationNodeState(node: any, role: string): any {
        const runtime = this.orchestrationNodeMap(role)[String(node?.id || node?.node_id || '').trim()];
        if (!runtime) return node;

        const runtimeStatus = String(runtime?.status || '').trim();
        const runtimeReady = runtime?.ready === true;
        const merged: any = {
            ...node,
            orchestration_status: runtimeStatus,
            orchestration_message: runtime?.message || node?.orchestration_message || '',
            cluster_deploy_status: runtimeStatus || node?.cluster_deploy_status || '',
            ready: runtimeReady || !!node?.ready,
            opa: runtime?.opa || node?.opa || null,
        };
        if (runtime?.power_state) merged.power_status = runtime.power_state;
        if (runtime?.boot_type) merged.boot_type = runtime.boot_type;
        if (role === 'relay' && runtimeReady) {
            merged.cluster_deploy_status = 'relay-ready';
        }
        if (role === 'compute' && runtimeStatus === 'deployed') {
            merged.cluster_deploy_status = 'deployed';
        }
        return merged;
    }

    public deploymentTreeNodes(): any[] {
        const relayNodes = this.isRelayDeployment()
            ? this.targetRelayServers().map((node: any) => this.mergeOrchestrationNodeState({ ...node, tree_role: 'relay' }, 'relay'))
            : [];
        const computeNodes = this.targetComputeNodes().map((node: any) => this.mergeOrchestrationNodeState({ ...node, tree_role: 'compute' }, 'compute'));
        return [...relayNodes, ...computeNodes]
            .filter((node: any) => this.nodeMatchesTypeFilter(node))
            .filter((node: any) => this.nodeMatchesStatusFilter(node))
            .filter((node: any) => this.nodeMatchesSearch(node));
    }

    private deploymentStageFilteredNodes(nodes: any[]): any[] {
        return (nodes || [])
            .filter((node: any) => this.nodeMatchesStatusFilter(node))
            .filter((node: any) => this.nodeMatchesSearch(node));
    }

    public relayStageNodes(): any[] {
        if (!this.isRelayDeployment()) return [];
        return this.targetRelayServers().map((node: any) => this.mergeOrchestrationNodeState({ ...node, tree_role: 'relay' }, 'relay'));
    }

    public computeStageNodes(): any[] {
        return this.targetComputeNodes().map((node: any) => this.mergeOrchestrationNodeState({ ...node, tree_role: 'compute' }, 'compute'));
    }

    public relayStageRows(): any[] {
        return this.deploymentStageFilteredNodes(this.relayStageNodes()).slice(0, Number(this.nodeRowsLimit || 50));
    }

    public computeStageRows(): any[] {
        return this.deploymentStageFilteredNodes(this.computeStageNodes()).slice(0, Number(this.nodeRowsLimit || 50));
    }

    public relayStageStats(): any {
        return this.deployStats(this.relayStageNodes());
    }

    public computeStageStats(): any {
        return this.deployStats(this.computeStageNodes());
    }

    private orchestrationStepByKey(key: string): any {
        return (this.relayJobSteps() || []).find((step: any) => String(step?.key || '') === key) || null;
    }

    public orchestrationStepTitle(key: string): string {
        const titles: any = {
            preflight: 'Preflight',
            'relay-deploy': 'Relay image deploy',
            'relay-ready': 'Relay ready check',
            'compute-pxe-prepare': 'Computing PXE prepare',
            'relay-script': 'Relay script execute',
            'compute-power-off': 'Computing power off',
            'compute-deploy': 'Computing PXE deploy',
            'compute-ready': 'Computing ready check',
        };
        return titles[key] || key;
    }

    private orchestrationStepsByKeys(keys: string[]): any[] {
        return keys.map((key: string) => {
            const step = this.orchestrationStepByKey(key);
            if (step) return step;
            return {
                key,
                title: this.orchestrationStepTitle(key),
                status: 'pending',
                message: this.relayOrchestrationJob ? '' : 'orchestration 대기',
                success_count: 0,
                total_count: this.orchestrationStepTargetCount(key),
            };
        });
    }

    public relayStageOrchestrationSteps(): any[] {
        return this.orchestrationStepsByKeys(['preflight', 'relay-deploy', 'relay-ready']);
    }

    public computeStageOrchestrationSteps(): any[] {
        return this.orchestrationStepsByKeys(['compute-pxe-prepare', 'relay-script', 'compute-power-off', 'compute-deploy', 'compute-ready']);
    }

    public orchestrationStepStatusLabel(step: any): string {
        const status = this.normalizedStatus(step?.status);
        if (status === 'completed') return '완료';
        if (status === 'failed') return '실패';
        if (status === 'in_progress' || status === 'running') return '진행 중';
        if (status === 'pending') return '대기';
        return status || '-';
    }

    private orchestrationFailureStatus(value: any): boolean {
        const status = this.normalizedStatus(value);
        return status.includes('fail')
            || status.includes('error')
            || status.includes('cancel')
            || status === 'review-needed';
    }

    private orchestrationStepKeyMatches(stepKey: any, candidate: any): boolean {
        const step = String(stepKey || '').trim().toLowerCase().replace(/_/g, '-');
        const target = String(candidate || '').trim().toLowerCase().replace(/_/g, '-');
        if (!step || !target) return false;
        if (step === target || step.includes(target) || target.includes(step)) return true;
        if (step === 'preflight') {
            return ['environment', 'subnets', 'relay-servers', 'computing-nodes'].includes(target);
        }
        return false;
    }

    private orchestrationFailureRole(value: any, stepKey: string): string {
        const role = String(value || '').trim().toLowerCase();
        if (role.includes('relay')) return 'Relay';
        if (role.includes('comput')) return 'Compute';
        if (String(stepKey || '').startsWith('relay-')) return 'Relay';
        if (stepKey === 'preflight') return 'Node';
        return 'Compute';
    }

    private orchestrationFailureDetails(row: any): string[] {
        const values: any[] = [
            row?.message,
            row?.detail,
            row?.error,
            row?.failure_reason,
            row?.power_message,
            row?.orchestration_message,
        ];
        for (const error of (Array.isArray(row?.errors) ? row.errors : [])) {
            if (typeof error === 'string') {
                values.push(error);
                continue;
            }
            const title = String(error?.title || '').trim();
            const detail = String(error?.detail || error?.message || '').trim();
            const code = String(error?.code || '').trim();
            values.push([title, detail, code ? '코드: ' + code : ''].filter(Boolean).join(' · '));
        }
        return Array.from(new Set(
            values.map((value: any) => String(value || '').trim()).filter((value: string) => !!value)
        ));
    }

    private orchestrationFailureSourceNodes(stepKey: string): any[] {
        const jobRelays = Array.isArray(this.relayOrchestrationJob?.relay_servers)
            ? this.relayOrchestrationJob.relay_servers
            : [];
        const jobComputes = Array.isArray(this.relayOrchestrationJob?.computing_nodes)
            ? this.relayOrchestrationJob.computing_nodes
            : [];
        const relays = jobRelays.length > 0 ? jobRelays : this.relayStageNodes();
        const computes = jobComputes.length > 0 ? jobComputes : this.computeStageNodes();

        if (stepKey === 'preflight') return [...relays, ...computes];
        if (stepKey === 'direct-compute' || stepKey.startsWith('compute-')) return computes;
        if (stepKey.startsWith('relay-')) return relays;
        return [...relays, ...computes];
    }

    private orchestrationEvidenceMatchesNode(evidence: string, node: any): boolean {
        const probe = String(evidence || '').toLowerCase();
        if (!probe) return false;
        const tokens = [
            node?.name,
            node?.node_name,
            node?.target_name,
            node?.ip_address,
            node?.bmc_ip,
            node?.mac_address,
        ].map((value: any) => String(value || '').trim().toLowerCase()).filter((value: string) => value.length >= 3);
        if (tokens.some((token: string) => probe.includes(token))) return true;

        const nodeId = String(node?.node_id ?? node?.target_id ?? node?.id ?? '').trim().toLowerCase();
        if (!nodeId) return false;
        return probe.includes('node ' + nodeId)
            || probe.includes('node #' + nodeId)
            || probe.includes('#' + nodeId)
            || probe.includes(nodeId + ':');
    }

    private orchestrationNodeFailedForStep(node: any, stepKey: string, stepFailed: boolean, evidence: string): boolean {
        const rawStatus = [
            node?.status,
            node?.deploy_status,
            node?.cluster_deploy_status,
            node?.orchestration_status,
        ].map((value: any) => String(value || '')).join(' ');
        const statusFailed = this.orchestrationFailureStatus(rawStatus);
        let stageFailed = false;

        if (stepKey === 'compute-pxe-prepare') stageFailed = !!node?.pxe_prepare_failed;
        else if (stepKey === 'compute-power-off') stageFailed = !!node?.power_off_failed;
        else if (stepKey === 'compute-deploy') stageFailed = !!node?.deploy_operation_failed;
        else if (stepKey === 'compute-ready' || stepKey === 'direct-compute') {
            stageFailed = statusFailed || this.nodeDeployBucket(node) === 'failed';
        } else if (stepKey === 'relay-deploy' || stepKey === 'relay-ready' || stepKey === 'relay-script') {
            stageFailed = statusFailed;
        }

        const message = this.orchestrationFailureDetails(node).join(' ');
        const messageFailed = /(fail|error|timeout|timed out|refused|unreachable|denied|missing|not found)/i.test(message);
        return stageFailed
            || (stepFailed && messageFailed)
            || (stepFailed && this.orchestrationEvidenceMatchesNode(evidence, node));
    }

    public orchestrationStepErrorRows(step: any): any[] {
        const stepKey = String(step?.key || '').trim().toLowerCase().replace(/_/g, '-');
        const stepFailed = this.orchestrationFailureStatus(step?.status) || Number(step?.failed_count || 0) > 0;
        const rows = new Map<string, any>();
        const evidence: string[] = [String(step?.message || '').trim()].filter(Boolean);

        const addRow = (row: any, fallbackRole: string = '') => {
            const nodeId = String(row?.node_id ?? row?.target_id ?? row?.id ?? '').trim();
            const name = String(row?.name || row?.node_name || row?.target_name || '').trim();
            if (!nodeId && !name) return;
            const roleLabel = this.orchestrationFailureRole(
                row?.role || row?.kind || fallbackRole,
                stepKey,
            );
            const details = this.orchestrationFailureDetails(row);
            const stepMessage = String(step?.message || '').trim();
            const failureDetail = details.find((value: string) =>
                /(fail|error|timeout|timed out|refused|unreachable|denied|missing|not found|실패|오류|시간 초과|연결 거부|누락)/i.test(value)
            );
            const message = failureDetail || stepMessage || details[0] || '배포 단계에서 오류가 발생했습니다.';
            const mergedDetails = Array.from(new Set([message, ...details].filter(Boolean)));
            const failureStatus = [
                row?.status,
                row?.deploy_status,
                row?.cluster_deploy_status,
                row?.orchestration_status,
                row?.verdict,
            ].map((value: any) => String(value || '').trim()).find((value: string) => this.orchestrationFailureStatus(value));
            const key = roleLabel + ':' + (nodeId || name.toLowerCase());
            const previous = rows.get(key);
            if (previous) {
                previous.details = Array.from(new Set([...(previous.details || []), ...mergedDetails]));
                if (!previous.message) previous.message = message;
                return;
            }
            rows.set(key, {
                node_id: nodeId,
                name: name || (nodeId ? 'Node #' + nodeId : 'Unknown node'),
                role_label: roleLabel,
                status: failureStatus || 'failed',
                message,
                details: mergedDetails,
            });
        };

        const failedNodes = [
            ...(stepKey === 'preflight' && Array.isArray(this.relayPreflightReport?.failed_nodes)
                ? this.relayPreflightReport.failed_nodes
                : []),
            ...(Array.isArray(this.relayOrchestrationJob?.failed_nodes) ? this.relayOrchestrationJob.failed_nodes : []),
        ];
        for (const row of failedNodes) {
            const rowStep = row?.step_key || row?.step || row?.stage || '';
            if (stepKey !== 'preflight' && rowStep && !this.orchestrationStepKeyMatches(stepKey, rowStep)) continue;
            const details = this.orchestrationFailureDetails(row);
            evidence.push(...details);
            if (stepFailed || stepKey === 'preflight' || this.orchestrationFailureStatus(row?.status)) {
                addRow(row);
            }
        }

        const stageEvents = this.relayDiagnosticStageEvents();
        for (const event of stageEvents) {
            const eventStatus = [
                event?.status,
                event?.severity,
                event?.verdict,
                event?.result,
            ].map((value: any) => String(value || '')).join(' ');
            if (!this.orchestrationFailureStatus(eventStatus)) continue;
            const eventStage = event?.stage || event?.step_key || event?.key || event?.action || '';
            if (!this.orchestrationStepKeyMatches(stepKey, eventStage)) continue;
            const details = this.orchestrationFailureDetails(event);
            evidence.push(...details);
            addRow(event, event?.kind || '');
        }

        const evidenceText = evidence.filter(Boolean).join(' ');
        for (const node of this.orchestrationFailureSourceNodes(stepKey)) {
            if (this.orchestrationNodeFailedForStep(node, stepKey, stepFailed, evidenceText)) {
                addRow(node, stepKey.startsWith('relay-') ? 'relay' : 'compute');
            }
        }

        return Array.from(rows.values());
    }

    public orchestrationStepHasError(step: any): boolean {
        return this.orchestrationFailureStatus(step?.status)
            || Number(step?.failed_count || 0) > 0;
    }

    public orchestrationStepErrorButtonTitle(step: any): string {
        const count = this.orchestrationStepErrorRows(step).length;
        return count > 0 ? '실패 노드 ' + count + '개 확인' : 'Orchestration 오류 상세 확인';
    }

    public directComputeErrorStep(): any {
        const stats = this.computeStageStats();
        return {
            key: 'direct-compute',
            title: 'Direct Compute 배포',
            status: Number(stats?.failed || 0) > 0 ? 'failed' : this.deploymentStatusKey(stats),
            message: Number(stats?.failed || 0) > 0
                ? this.formatNumber(stats.failed) + '개 Compute 노드에서 배포 오류가 발생했습니다.'
                : '',
            failed_count: Number(stats?.failed || 0),
            total_count: Number(stats?.total || 0),
        };
    }

    public async openOrchestrationErrorModal(step: any) {
        if (!this.orchestrationStepHasError(step)) return;
        this.orchestrationErrorStep = { ...(step || {}) };
        this.orchestrationErrorRows = this.orchestrationStepErrorRows(step);
        this.orchestrationErrorModalOpen = true;
        await this.service.render();
    }

    public async closeOrchestrationErrorModal() {
        if (!this.orchestrationErrorModalOpen) return;
        this.orchestrationErrorModalOpen = false;
        this.orchestrationErrorStep = null;
        this.orchestrationErrorRows = [];
        await this.service.render();
    }

    public openOrchestrationErrorNode(row: any) {
        const nodeId = String(row?.node_id || '').trim();
        if (!nodeId) return;
        this.orchestrationErrorModalOpen = false;
        this.orchestrationErrorStep = null;
        this.orchestrationErrorRows = [];
        this.service.href('/kiera/nodes/' + nodeId);
    }

    private orchestrationStepTargetCount(key: string): number {
        if (key === 'preflight') {
            return this.relayStageNodes().length + this.computeStageNodes().length;
        }
        if (['relay-deploy', 'relay-ready', 'relay-script'].includes(key)) {
            return this.relayStageNodes().length;
        }
        if (['compute-pxe-prepare', 'compute-power-off', 'compute-deploy', 'compute-ready'].includes(key)) {
            return this.computeStageNodes().length;
        }
        return 0;
    }

    public orchestrationStepProgress(step: any): any {
        const key = String(step?.key || '');
        const providedTotal = Number(step?.total_count);
        const total = Math.max(
            0,
            Number.isFinite(providedTotal) ? providedTotal : this.orchestrationStepTargetCount(key)
        );
        const providedSuccess = Number(
            step?.success_count !== undefined ? step?.success_count : step?.completed_count
        );
        let success = Number.isFinite(providedSuccess) ? providedSuccess : 0;
        if (this.normalizedStatus(step?.status) === 'completed') success = total;
        success = Math.min(total, Math.max(0, success));
        return { success, total };
    }

    public orchestrationStepProgressLabel(step: any): string {
        const progress = this.orchestrationStepProgress(step);
        return `${this.formatNumber(progress.success)} / ${this.formatNumber(progress.total)}`;
    }

    public orchestrationStepElapsedLabel(step: any): string {
        if (!step || !String(step?.started || '').trim()) return '-';

        const completed = !!String(step?.completed || '').trim();
        const apiSeconds = Number(completed ? step?.duration_seconds : step?.elapsed_seconds);
        if (Number.isFinite(apiSeconds) && apiSeconds >= 0) {
            return apiSeconds === 0 ? '0s' : this.durationSecondsLabel(Math.round(apiSeconds));
        }

        const startedAt = this.parseLogDate(step?.started);
        const completedAt = completed ? this.parseLogDate(step?.completed) : new Date();
        if (!startedAt || !completedAt || completedAt.getTime() < startedAt.getTime()) return '-';
        const elapsedSeconds = Math.max(0, Math.round((completedAt.getTime() - startedAt.getTime()) / 1000));
        return elapsedSeconds === 0 ? '0s' : this.durationSecondsLabel(elapsedSeconds);
    }

    public relayStageReadyCount(): number {
        const relayReadyStep = this.orchestrationStepByKey('relay-ready');
        if (this.normalizedStatus(relayReadyStep?.status) === 'completed') {
            return this.relayStageNodes().length;
        }
        return this.relayStageNodes().filter((node: any) => {
            const status = `${this.normalizedStatus(node?.status)} ${this.normalizedStatus(node?.deploy_status)} ${this.normalizedStatus(node?.cluster_deploy_status)}`;
            return !!node?.ready || status.includes('relay-ready') || status.includes('ready') || this.nodeDeployBucket(node) === 'deployed';
        }).length;
    }

    public stageSummaryText(stats: any): string {
        return `완료 ${this.formatNumber(stats?.deployed || 0)} · 진행 ${this.formatNumber(stats?.in_progress || 0)} · 실패 ${this.formatNumber(stats?.failed || 0)} · 대기 ${this.formatNumber(stats?.pending || 0)}`;
    }

    public opaForNode(node: any): any {
        return node?.opa || {};
    }

    public opaStagesForNode(node: any): any[] {
        return Array.isArray(this.opaForNode(node)?.stages) ? this.opaForNode(node).stages : [];
    }

    public opaStageStatusLabel(statusOrStage: any): string {
        const status = this.normalizedStatus(
            typeof statusOrStage === 'object' ? statusOrStage?.status : statusOrStage
        );
        if (status === 'completed') return '완료';
        if (status === 'failed') return '실패';
        if (status === 'running' || status === 'in_progress') return '진행 중';
        if (status === 'not-applicable') return '대상 아님';
        return '대기';
    }

    public opaStageLightClass(statusOrStage: any): string {
        const status = this.normalizedStatus(
            typeof statusOrStage === 'object' ? statusOrStage?.status : statusOrStage
        );
        if (status === 'completed') return 'bg-emerald-500 ring-emerald-100';
        if (status === 'failed') return 'bg-rose-500 ring-rose-100';
        if (status === 'running' || status === 'in_progress') return 'bg-blue-500 ring-blue-100 animate-pulse';
        if (status === 'not-applicable') return 'bg-slate-200 ring-slate-100';
        return 'bg-amber-300 ring-amber-100';
    }

    public opaStageCardClass(statusOrStage: any): string {
        const status = this.normalizedStatus(
            typeof statusOrStage === 'object' ? statusOrStage?.status : statusOrStage
        );
        if (status === 'completed') return 'border-emerald-200 bg-emerald-50/60';
        if (status === 'failed') return 'border-rose-200 bg-rose-50/60';
        if (status === 'running' || status === 'in_progress') return 'border-blue-200 bg-blue-50/60';
        return 'border-slate-200 bg-slate-50';
    }

    public opaElapsedLabel(stage: any): string {
        const seconds = Number(stage?.elapsed_seconds || 0);
        return Number.isFinite(seconds) && seconds > 0 ? this.durationSecondsLabel(Math.round(seconds)) : '-';
    }

    public opaStageTitle(stage: any): string {
        const parts = [
            String(stage?.label || stage?.key || 'OPA'),
            this.opaStageStatusLabel(stage),
        ];
        const elapsed = this.opaElapsedLabel(stage);
        if (elapsed !== '-') parts.push(elapsed);
        const detail = String(stage?.failure_reason || stage?.message || '').trim();
        if (detail) parts.push(detail);
        return parts.join(' · ');
    }

    public opaProgressStages(): any[] {
        const jobStages = this.relayOrchestrationJob?.opa_progress;
        if (Array.isArray(jobStages) && jobStages.length) return jobStages;

        const catalog = [
            { key: 'prepare', label: 'OPA 준비' },
            { key: 'network', label: 'OPA 연결' },
            { key: 'rootfs', label: 'RootFS 수신' },
        ];
        const nodes = this.computeStageNodes().filter((node: any) => this.opaForNode(node)?.enabled);
        return catalog.map((catalogStage: any) => {
            const rows = nodes.map((node: any) => this.opaStagesForNode(node).find((stage: any) => stage?.key === catalogStage.key))
                .filter((stage: any) => !!stage);
            const counts: any = { pending: 0, running: 0, completed: 0, failed: 0 };
            let failureReason = '';
            let elapsedSeconds = 0;
            for (const row of rows) {
                const status = this.normalizedStatus(row?.status);
                const key = ['running', 'completed', 'failed'].includes(status) ? status : 'pending';
                counts[key] += 1;
                elapsedSeconds = Math.max(elapsedSeconds, Number(row?.elapsed_seconds || 0));
                if (key === 'failed' && !failureReason) failureReason = String(row?.message || '');
            }
            const status = counts.failed
                ? 'failed'
                : rows.length && counts.completed === rows.length
                    ? 'completed'
                    : (counts.running || counts.completed) ? 'running' : 'pending';
            return {
                ...catalogStage,
                status,
                counts,
                nodes_total: rows.length,
                elapsed_seconds: elapsedSeconds,
                failure_reason: failureReason,
            };
        });
    }

    public relayNameForCompute(node: any): string {
        const opaRelayName = String(this.opaForNode(node)?.relay_server_name || '').trim();
        if (opaRelayName) return opaRelayName;
        const relayId = String(node?.cluster_relay_id || node?.relay_server_id || node?.relay_server_node_id || '').trim();
        if (!relayId) return '';
        const relay = this.activeRelayNodes().find((row: any) => String(row?.id || '') === relayId || String(row?.node_id || '') === relayId);
        return relay?.name || relay?.ip_address || relayId;
    }

    private nodeTreeGroupKey(node: any): string {
        if (!this.isRelayDeployment()) return this.nodeGroupKey(node);
        if (String(node?.tree_role || '') === 'relay') return this.groupKey(node);
        const relay = this.activeRelayNodes().find((row: any) => String(row.id) === String(node?.cluster_relay_id || ''));
        return relay ? this.groupKey(relay) : 'unassigned';
    }

    public nodeTreeGroups(): any[] {
        const rows = this.deploymentTreeNodes();
        const relayRowsByKey: any = {};
        this.relayGroupRows().forEach((row: any) => relayRowsByKey[row.key] = row);
        const groups: any[] = [];
        const groupMap: any = {};
        for (const node of rows) {
            const key = this.nodeTreeGroupKey(node);
            if (!groupMap[key]) {
                const relayRow = relayRowsByKey[key] || {};
                const group = {
                    key,
                    name: relayRow.name || (key === 'unassigned' ? 'Unassigned' : (key.startsWith('group:') ? `Group ${key.replace('group:', '')}` : 'Default Group')),
                    meta: relayRow.vlan_id ? `VLAN ${relayRow.vlan_id}` : (relayRow.cidr || relayRow.gateway || ''),
                    nodes: [],
                };
                groupMap[key] = group;
                groups.push(group);
            }
            groupMap[key].nodes.push(node);
        }
        return groups.map((group: any) => {
            const stats = this.deployStats(group.nodes.filter((node: any) => String(node?.tree_role || '') === 'compute'));
            return {
                ...group,
                relay_count: group.nodes.filter((node: any) => String(node?.tree_role || '') === 'relay').length,
                compute_count: group.nodes.filter((node: any) => String(node?.tree_role || '') === 'compute').length,
                stats,
            };
        });
    }

    public isNodeTreeGroupExpanded(key: any): boolean {
        const normalized = String(key || 'default');
        return this.expandedNodeTreeGroups[normalized] !== false;
    }

    public toggleNodeTreeGroup(key: any) {
        const normalized = String(key || 'default');
        this.expandedNodeTreeGroups[normalized] = !this.isNodeTreeGroupExpanded(normalized);
        this.service.render();
    }

    public isNodeSelected(node: any): boolean {
        return !!this.selectedNodeIds[String(node?.id || '')];
    }

    public toggleNodeSelected(node: any) {
        const key = String(node?.id || '');
        if (!key) return;
        if (this.selectedNodeIds[key]) delete this.selectedNodeIds[key];
        else this.selectedNodeIds[key] = true;
        if (this.isRelayDeployment()) {
            this.relayPreflightReport = null;
            this.relayAllowOverride = false;
        }
        this.service.render();
    }

    public toggleNodeGroupSelection(group: any) {
        const nodes = (group?.nodes || []).filter((node: any) => String(node?.tree_role || '') === 'compute');
        if (nodes.length === 0) return;
        const allSelected = nodes.every((node: any) => this.isNodeSelected(node));
        nodes.forEach((node: any) => {
            const key = String(node?.id || '');
            if (!key) return;
            if (allSelected) delete this.selectedNodeIds[key];
            else this.selectedNodeIds[key] = true;
        });
        this.service.render();
    }

    public isNodeGroupSelected(group: any): boolean {
        const nodes = (group?.nodes || []).filter((node: any) => String(node?.tree_role || '') === 'compute');
        return nodes.length > 0 && nodes.every((node: any) => this.isNodeSelected(node));
    }

    public selectedRelayNodes(): any[] {
        return this.targetRelayServers().filter((node: any) => this.selectedNodeIds[String(node?.id || '')]);
    }

    public selectedComputeNodes(): any[] {
        return this.targetComputeNodes().filter((node: any) => this.selectedNodeIds[String(node?.id || '')]);
    }

    public selectedTargetNodes(): any[] {
        return this.selectedComputeNodes();
    }

    public selectedNodeCount(): number {
        if (this.isRelayDeployment()) return this.selectedRelayNodes().length + this.selectedComputeNodes().length;
        return this.selectedTargetNodes().length;
    }

    public relayDeployTargetNodes(): any[] {
        if (!this.showNodeSelectionCheckboxes()) return this.targetRelayServers();
        return this.selectedRelayNodes();
    }

    public nodeRowsLimitOptions(): number[] {
        return [50, 100, 200, 500];
    }

    public nodePowerLabel(node: any): string {
        const power = String(node?.power_status || '').trim();
        return power ? power : 'Unknown';
    }

    public nodePowerClass(node: any): string {
        const power = this.normalizedStatus(node?.power_status);
        if (power === 'on') return 'text-emerald-600';
        if (power === 'off') return 'text-rose-600';
        return 'text-slate-500';
    }

    public nodeTreeRoleLabel(node: any): string {
        return String(node?.tree_role || '') === 'relay' ? this.nodeRoleLabel(node) : 'Compute';
    }

    public saveDeploymentConfiguration() {
        this.deployMenuOpen = false;
        const message = '배포 설정을 화면 상태에 저장했습니다.';
        this.deployMessage = this.isRelayDeployment() ? '' : message;
        this.relayMessage = this.isRelayDeployment() ? message : '';
        this.service.render();
    }

    public async deployAction(action: string) {
        this.deployMenuOpen = false;
        if (this.isRelayDeployment()) {
            this.beginRelayDiagnostic(
                action === 'precheck' ? 'precheck' : 'deploy',
                action === 'precheck' ? 'Pre-check 대상과 설정을 확인하고 있습니다.' : '배포 대상과 설정을 확인하고 있습니다.',
            );
        }
        if (action === 'precheck') {
            if (this.isRelayDeployment()) {
                if (this.showNodeSelectionCheckboxes()) {
                    const relayServers = this.selectedRelayNodes();
                    const computingNodes = this.selectedComputeNodes();
                    if (relayServers.length === 0 || computingNodes.length === 0) {
                        this.relayMessage = '선택 Pre-check는 relay 서버와 compute 노드를 함께 선택해야 합니다.';
                        this.setRelayDiagnosticMessage(this.relayMessage, 'client-target-selection');
                        await this.service.render();
                        return;
                    }
                    const selectedRelayIds = new Set(relayServers.map((node: any) => String(node?.id || '')));
                    const missingRelayNodes = computingNodes.filter((node: any) => {
                        const relayId = String(node?.cluster_relay_id || node?.relay_server_id || node?.relay_server_node_id || '');
                        return !relayId || !selectedRelayIds.has(relayId);
                    });
                    if (missingRelayNodes.length > 0) {
                        const names = missingRelayNodes.slice(0, 5).map((node: any) => node.name || node.id).join(', ');
                        this.relayMessage = `선택한 compute 노드의 relay 서버도 함께 선택하세요: ${names}`;
                        this.setRelayDiagnosticMessage(this.relayMessage, 'client-relay-assignment');
                        await this.service.render();
                        return;
                    }
                    await this.runRelayPreflight(true, relayServers, computingNodes, 'selected');
                } else {
                    await this.runRelayPreflight();
                }
            }
            else {
                this.deployMessage = '직접 배포는 실행 시 이미지와 대상 노드를 검증합니다.';
                await this.service.render();
            }
            return;
        }
        if (action === 'selected') {
            if (this.selectedNodeCount() === 0) {
                const message = '선택된 노드가 없습니다.';
                this.deployMessage = message;
                this.relayMessage = message;
                if (this.isRelayDeployment()) this.setRelayDiagnosticMessage(message, 'client-target-selection');
                await this.service.render();
                return;
            }
            if (!this.isRelayDeployment()) {
                await this.deployDirectTarget(this.selectedTargetNodes(), '선택 노드');
                return;
            }

            const relayServers = this.selectedRelayNodes();
            const computingNodes = this.selectedComputeNodes();
            if (computingNodes.length === 0) {
                await this.deployRelayServers(relayServers);
                return;
            }

            const selectedRelayIds = new Set(relayServers.map((node: any) => String(node?.id || '')));
            const missingRelayNodes = computingNodes.filter((node: any) => {
                const relayId = String(node?.cluster_relay_id || node?.relay_server_id || node?.relay_server_node_id || '');
                return !relayId || !selectedRelayIds.has(relayId);
            });
            if (missingRelayNodes.length > 0) {
                const names = missingRelayNodes.slice(0, 5).map((node: any) => node.name || node.id).join(', ');
                this.relayMessage = `선택한 compute 노드의 relay 서버도 함께 선택하세요: ${names}`;
                this.setRelayDiagnosticMessage(this.relayMessage, 'client-relay-assignment');
                await this.service.render();
                return;
            }

            await this.startRelayDeployment({
                relayServers,
                computingNodes,
                executionMode: 'selected',
                label: '선택 노드',
            });
            return;
        }
        if (action === 'failed' && !this.isRelayDeployment()) {
            const failedNodes = this.targetComputeNodes().filter((node: any) => this.nodeDeployBucket(node) === 'failed');
            await this.deployDirectTarget(failedNodes, '실패 노드');
            return;
        }
        if (action === 'failed' && this.isRelayDeployment()) {
            this.relayMessage = '릴레이 배포의 실패 재시도는 현재 선택 범위 orchestration에서 처리합니다. Deploy Cluster 실행 전 Pre-check를 확인하세요.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-action-not-supported');
            await this.service.render();
            return;
        }
        if (this.isRelayDeployment()) await this.startRelayDeployment();
        else await this.deployDirectTarget();
    }

    public advancedConfigSections(): any[] {
        return [
            { key: 'main', title: 'Main Server / SSH', count: 12, icon: 'bx bx-terminal' },
            { key: 'database', title: 'Database', count: 10, icon: 'bx bx-data' },
            { key: 'storage', title: 'NFS / Storage', count: 3, icon: 'bx bx-cloud' },
            { key: 'dhcp', title: 'DHCP / Relay', count: 24, icon: 'bx bx-git-branch' },
            { key: 'transfer', title: 'Transfer', count: 12, icon: 'bx bx-transfer' },
            { key: 'tasks', title: 'Deploy Tasks', count: 6, icon: 'bx bx-task' },
            { key: 'environment', title: 'Relay Environment', count: 17, icon: 'bx bx-cog' },
            { key: 'zabbix', title: 'Zabbix', count: 9, icon: 'bx bx-pulse' },
            { key: 'juju', title: 'Juju', count: 11, icon: 'bx bx-cube' },
            { key: 'permissions', title: 'Env File Permissions', count: 3, icon: 'bx bx-lock-alt' },
        ];
    }

    private async appApi(appId: string, name: string, params: any = {}) {
        const formData = new FormData();
        Object.entries(params || {}).forEach(([key, value]: any) => {
            if (value !== undefined && value !== null) formData.append(key, String(value));
        });
        try {
            const response = await fetch(`/wiz/api/${appId}/${name}`, {
                method: 'POST',
                body: formData,
                credentials: 'same-origin',
            });
            const result = await response.json();
            return { code: result?.code || 0, data: result?.data ?? result };
        } catch (error: any) {
            return { code: 0, data: { message: error?.message || 'API request failed.' } };
        }
    }

    private async clusterManageApi(name: string, params: any = {}) {
        return this.appApi('page.kiera.clusters.item', name, params);
    }

    private async relayApi(name: string, params: any = {}) {
        return this.appApi('page.kiera.relay', name, params);
    }

    private async clusterDeployApi(name: string, params: any = {}) {
        return this.appApi('page.kiera.cluster.deploy.item', name, params);
    }

    public async loadAdvancedEnv(shouldRender: boolean = true) {
        if (this.advancedEnvLoading) return;
        this.advancedEnvLoading = true;
        this.advancedEnvMessage = '';
        if (shouldRender) await this.service.render();
        const { code, data } = await this.clusterDeployApi('advanced_env_get', {
            file_key: this.advancedEnvSelectedFile,
        });
        this.advancedEnvLoading = false;
        if (code === 200) {
            this.advancedEnvFiles = Array.isArray(data?.files) ? data.files : [];
            this.advancedEnvRows = Array.isArray(data?.rows) ? data.rows : [];
            this.advancedEnvSelectedFile = String(data?.file_key || this.advancedEnvSelectedFile || 'relay_all');
            this.advancedEnvLoaded = true;
        } else {
            this.advancedEnvMessage = data?.message || '환경 변수 파일을 불러오지 못했습니다.';
        }
        if (shouldRender) await this.service.render();
    }

    public async onAdvancedEnvFileChanged() {
        this.advancedEnvLoaded = false;
        await this.loadAdvancedEnv(true);
    }

    public advancedEnvFileLabel(): string {
        const file = (this.advancedEnvFiles || []).find((item: any) => String(item.key) === String(this.advancedEnvSelectedFile));
        return file?.label || this.advancedEnvSelectedFile || '-';
    }

    public advancedEnvRowsForSection(): any[] {
        const section = String(this.advancedDrawerSection || 'main');
        return (this.advancedEnvRows || []).filter((row: any) => String(row?.section || '') === section);
    }

    public advancedEnvSectionCount(sectionKey: any): number {
        const key = String(sectionKey || '');
        return (this.advancedEnvRows || []).filter((row: any) => String(row?.section || '') === key).length;
    }

    private advancedEnvValueMap(): any {
        const values: any = {};
        for (const row of this.advancedEnvRows || []) {
            const key = String(row?.key || '').trim();
            if (!key) continue;
            if (String(row.value ?? '') === String(row.original_value ?? '')) continue;
            values[key] = row.value ?? '';
        }
        return values;
    }

    public advancedEnvDirtyCount(): number {
        return (this.advancedEnvRows || []).filter((row: any) => {
            const key = String(row?.key || '').trim();
            if (!key) return false;
            return String(row.value ?? '') !== String(row.original_value ?? '');
        }).length;
    }

    private advancedEnvDefaultValue(row: any): string {
        if (row && Object.prototype.hasOwnProperty.call(row, 'default_value')) {
            return String(row.default_value ?? '');
        }
        return String(row?.original_value ?? '');
    }

    public advancedEnvDefaultDiffCount(): number {
        return (this.advancedEnvRows || []).filter((row: any) => {
            const key = String(row?.key || '').trim();
            if (!key) return false;
            return String(row.value ?? '') !== this.advancedEnvDefaultValue(row);
        }).length;
    }

    public async restoreAdvancedEnvDefaults() {
        if (this.advancedEnvLoading || this.advancedEnvSaving) return;
        let restored = 0;
        for (const row of this.advancedEnvRows || []) {
            const defaultValue = this.advancedEnvDefaultValue(row);
            if (String(row.value ?? '') === defaultValue) continue;
            row.value = defaultValue;
            restored += 1;
        }
        this.advancedEnvMessage = restored > 0
            ? `${restored}개 env 값을 기본값으로 복원했습니다. 저장해야 파일에 반영됩니다.`
            : '복원할 변경 값이 없습니다.';
        await this.service.render();
    }

    public async saveAdvancedEnv() {
        if (this.advancedEnvSaving) return;
        this.advancedEnvSaving = true;
        this.advancedEnvMessage = '';
        await this.service.render();
        const { code, data } = await this.clusterDeployApi('advanced_env_save', {
            file_key: this.advancedEnvSelectedFile,
            values: JSON.stringify(this.advancedEnvValueMap()),
        });
        this.advancedEnvSaving = false;
        if (code === 200) {
            this.advancedEnvMessage = data?.message || '환경 변수 파일을 저장했습니다.';
            await this.loadAdvancedEnv(false);
        } else {
            this.advancedEnvMessage = data?.message || '환경 변수 파일 저장에 실패했습니다.';
        }
        await this.service.render();
    }

    public async loadDeploymentOptions(shouldRender: boolean = true) {
        if (this.deploymentLoading) return;
        this.deploymentLoading = true;
        this.deployMessage = '';
        this.relayMessage = '';
        if (shouldRender) await this.service.render();

        const requests: Promise<any>[] = [this.clusterManageApi('deploy_options', { id: this.id })];
        if (this.isRelayDeployment()) requests.push(this.relayApi('images'));
        const results = await Promise.all(requests);
        const optionResult = results[0];
        if (optionResult.code === 200) {
            this.images = optionResult.data?.images || optionResult.data?.rows || [];
        } else {
            this.deployMessage = optionResult.data?.message || '이미지 목록을 불러오지 못했습니다.';
        }

        if (this.isRelayDeployment()) {
            const relayResult = results[1];
            if (relayResult.code === 200) {
                this.relayImages = Array.isArray(relayResult.data) ? relayResult.data : (relayResult.data?.rows || relayResult.data?.images || []);
            } else {
                this.relayMessage = relayResult.data?.message || 'Relay 이미지 목록을 불러오지 못했습니다.';
            }
        }

        this.ensureDeploymentImageSelections();
        this.deploymentOptionsLoaded = true;
        this.deploymentLoading = false;
        if (shouldRender) await this.service.render();
    }

    public onDeployImageChanged() {
        this.deployMessage = '';
        this.service.render();
    }

    public onRelayDeployOptionChanged() {
        this.relayPreflightReport = null;
        this.relayAllowOverride = false;
        this.relayDiagnosticVisible = false;
        this.relayDiagnosticMessage = '';
        this.relayDiagnosticCode = '';
        this.relayMessage = '';
        this.service.render();
    }

    public async deployDirectTarget(nodes: any[] | null = null, label: string = '') {
        if (this.deploymentActionBusy()) return;
        if (!this.deploymentOptionsLoaded) await this.loadDeploymentOptions(false);
        const imageId = Number(this.deployForm.image_id || 0);
        const targetNodes = Array.isArray(nodes) ? nodes : this.targetComputeNodes();
        const targetLabel = label || this.deploymentTargetLabel();
        if (!imageId) {
            this.deployMessage = '이미지를 선택하세요.';
            await this.service.render();
            return;
        }
        if (targetNodes.length === 0) {
            this.deployMessage = '배포 대상 노드가 없습니다.';
            await this.service.render();
            return;
        }

        this.deploying = true;
        this.deployMessage = '';
        await this.service.render();
        try {
            const payload = {
                image_id: imageId,
                node_ids: targetNodes.map((node: any) => node.id),
                boot_mode: this.normalizedBootMode(),
                boot_type: this.requestedBootType(),
                boot_mode_persistence: this.bootModePersistence(),
            };
            const { code, data } = await this.clusterManageApi('deploy_cluster', {
                id: this.id,
                data: JSON.stringify(payload),
            });
            if (code === 200) {
                const operations = data?.operations || [];
                const message = `${operations.length || targetNodes.length}개 배포 작업을 큐에 등록했습니다.`;
                await this.load();
                this.deployMessage = message;
            } else {
                this.deployMessage = data?.message || '배포 요청에 실패했습니다.';
            }
        } finally {
            this.deploying = false;
            await this.service.render();
        }
    }

    private relayBoundedInteger(value: any, defaultValue: number, minimum: number, maximum: number): number {
        const parsed = Number.parseInt(String(value), 10);
        if (Number.isNaN(parsed)) return defaultValue;
        return Math.min(maximum, Math.max(minimum, parsed));
    }

    private normalizedRelayWindowSettings(): any {
        return {
            window_size: this.relayBoundedInteger(this.relayWindowSize, this.relayDefaultWindowSize, 1, this.relayMaxWindowSize),
            inter_window_gap_seconds: this.relayBoundedInteger(this.relayWindowGapSeconds, this.relayDefaultWindowGapSeconds, 0, this.relayMaxWindowGapSeconds),
        };
    }

    private normalizedOpaWaitSeconds(value: any): number {
        return this.relayBoundedInteger(
            value,
            this.opaWaitDefaultSeconds,
            this.opaWaitMinSeconds,
            this.opaWaitMaxSeconds,
        );
    }

    public normalizeOpaWaitSeconds(target: string) {
        if (target === 'compute') {
            this.computeOpaWaitSeconds = this.normalizedOpaWaitSeconds(this.computeOpaWaitSeconds);
        } else {
            this.relayOpaWaitSeconds = this.normalizedOpaWaitSeconds(this.relayOpaWaitSeconds);
        }
        this.service.render();
    }

    private optionEnabled(value: any): boolean {
        if (typeof value === 'boolean') return value;
        const text = String(value || '').trim().toLowerCase();
        return !['', '0', 'false', 'no', 'off', 'disable', 'disabled'].includes(text);
    }

    public onDeploymentScriptOptionChanged() {
        this.relayPreflightReport = null;
        this.relayAllowOverride = false;
        this.deployMessage = '';
        this.relayMessage = '';
        this.service.render();
    }

    private deploymentOptionsPayload(): any {
        const sshBootstrapEnabled = this.optionEnabled(this.sshBootstrap);
        const scriptBootstrapEnabled = this.optionEnabled(this.scriptBootstrap);
        return {
            relay_deployment_mode: this.normalizedDeploymentMode(this.relayDeploymentMode),
            compute_deployment_mode: this.normalizedDeploymentMode(this.computeDeploymentMode),
            relay_rootfs_transfer: this.relayRootfsTransfer,
            compute_rootfs_transfer: this.computeRootfsTransfer,
            relay_opa_wait_seconds: this.normalizedOpaWaitSeconds(this.relayOpaWaitSeconds),
            compute_opa_wait_seconds: this.normalizedOpaWaitSeconds(this.computeOpaWaitSeconds),
            boot_mode: this.normalizedBootMode(),
            boot_type: this.requestedBootType(),
            boot_mode_persistence: this.bootModePersistence(),
            ssh_bootstrap: sshBootstrapEnabled ? 'enabled' : 'disabled',
            script_bootstrap: scriptBootstrapEnabled ? 'enabled' : 'disabled',
            advanced_config: this.advancedConfigEnabled ? 'enabled' : 'disabled',
            ssh_bootstrap_enabled: sshBootstrapEnabled,
            script_bootstrap_enabled: scriptBootstrapEnabled,
            advanced_config_enabled: !!this.advancedConfigEnabled,
            post_deploy_zabbix_agent: !!this.postDeployZabbixAgent,
            post_deploy_zabbix_proxy: !!this.postDeployZabbixProxy,
            advanced_env_file: this.advancedEnvSelectedFile,
            advanced_env_values: this.advancedConfigEnabled ? this.advancedEnvValueMap() : {},
        };
    }

    private relayAssignments(relayServers: any[], computingNodes: any[]): any {
        const assignments: any = {};
        for (const server of relayServers || []) assignments[server.id] = [];
        for (const node of computingNodes || []) {
            const serverId = String(node.cluster_relay_id || '');
            if (!serverId) continue;
            if (!assignments[serverId]) assignments[serverId] = [];
            assignments[serverId].push(node.id);
        }
        return assignments;
    }

    private relayServerSnapshot(relayServers: any[]): any[] {
        return (relayServers || []).map((node: any) => ({
            node_id: node.id,
            relay_role: node.cluster_relay_role || '',
            dhcp_group_key: this.groupKey(node),
            relay_node_id: node.cluster_relay_id || '',
            boot_type: this.effectiveBootTypeForNode(node),
        }));
    }

    private relayServerPersistStatus(server: any): string {
        const bucket = this.nodeDeployBucket(server);
        if (bucket === 'deployed') return 'deployed';
        if (bucket === 'in_progress') return 'deploying';
        if (bucket === 'failed') return 'error';
        return 'pending';
    }

    private relayTargetObject(): any {
        const group = this.selectedDeploymentGroup();
        if (!group) return null;
        return {
            groupKey: group.key,
            name: group.name,
            subnet_name: group.subnet_name || '',
            vlan_id: group.vlan_id || '',
            cidr: group.cidr || '',
            gateway: group.gateway || '',
            dhcp_pool: group.dhcp_pool || '',
        };
    }

    private buildClusterRelayPayload(relayServers: any[] = this.activeRelayNodes(), computingNodes: any[] = this.computeNodes()): any {
        const computeWindowSettings = this.normalizedRelayWindowSettings();
        return {
            name: `${this.item?.name || this.id}-Relay`,
            is_dummy: false,
            compute_window_settings: computeWindowSettings,
            deployment_options: this.deploymentOptionsPayload(),
            clear_computing_nodes: computingNodes.length === 0,
            clear_cluster_node_config: relayServers.length === 0 && computingNodes.length === 0,
            node_selection: {
                mode: 'cluster',
                cluster_id: this.id,
                cluster_name: this.item?.name || '',
                relay_domain_keys: this.relayGroupRows().map((row: any) => row.key),
                relay_domain_metadata: this.relayDomainMetadata(),
                relay_node_ids: relayServers.map((node: any) => node.id),
                relay_candidate_node_ids: relayServers.map((node: any) => node.id),
                inactive_relay_node_ids: [],
                relay_server_configs: this.relayServerSnapshot(relayServers),
                computing_node_ids: computingNodes.map((node: any) => node.id),
                unassigned_computing_node_ids: computingNodes.filter((node: any) => !node.cluster_relay_id).map((node: any) => node.id),
                excluded_computing_node_ids: [],
                excluded_node_ids: [],
                assignments: this.relayAssignments(relayServers, computingNodes),
                all_assignments: this.relayAssignments(relayServers, computingNodes),
                compute_window_settings: computeWindowSettings,
            },
            relay_servers: relayServers.map((server: any) => ({
                node_id: server.id,
                image_id: this.relayForm.relay_image_id,
                dhcp_group_key: this.groupKey(server),
                is_dhcp_server: String(server.cluster_relay_role || '') === 'authority' ? 1 : 0,
                status: this.relayServerPersistStatus(server),
                ready: this.nodeDeployBucket(server) === 'deployed',
                boot_type: this.effectiveBootTypeForNode(server),
            })),
            computing_nodes: computingNodes.map((node: any) => ({
                node_id: node.id,
                relay_server_id: node.cluster_relay_id || '',
                relay_server_node_id: node.cluster_relay_id || '',
                boot_type: this.effectiveBootTypeForNode(node),
                status: this.nodeDeployBucket(node) === 'failed' ? 'failed' : 'pending',
            })),
        };
    }

    private buildClusterRelayRequestPayload(groupId: string = '', relayServers: any[] = this.targetRelayServers(), computingNodes: any[] = this.targetComputeNodes(), executionMode: string = 'scope'): any {
        const fullRelayServers = this.activeRelayNodes();
        const fullComputingNodes = this.computeNodes();
        return {
            group_id: groupId || this.relayCreatedId || '',
            target_relay_group_key: this.deploymentScope === 'group' ? this.selectedDeploymentGroupKey : '',
            target_relay_group: this.relayTargetObject(),
            group: this.buildClusterRelayPayload(fullRelayServers, fullComputingNodes),
            relay_servers: relayServers.map((server: any) => ({
                ...server,
                node_id: server.id,
                image_id: this.relayForm.relay_image_id,
                dhcp_group_key: this.groupKey(server),
                is_dhcp_server: String(server.cluster_relay_role || '') === 'authority' ? 1 : 0,
                boot_type: this.effectiveBootTypeForNode(server),
            })),
            computing_nodes: computingNodes.map((node: any) => ({
                ...node,
                node_id: node.id,
                relay_server_id: node.cluster_relay_id || '',
                relay_server_node_id: node.cluster_relay_id || '',
                boot_type: this.effectiveBootTypeForNode(node),
            })),
            assignments: this.relayAssignments(relayServers, computingNodes),
            all_assignments: this.relayAssignments(this.activeRelayNodes(), this.computeNodes()),
            relay_image_id: this.relayForm.relay_image_id,
            computing_image_id: this.relayForm.computing_image_id,
            compute_window_settings: this.normalizedRelayWindowSettings(),
            deployment_options: this.deploymentOptionsPayload(),
            execution_selection: {
                mode: executionMode,
                relay_node_ids: relayServers.map((node: any) => node.id),
                computing_node_ids: computingNodes.map((node: any) => node.id),
            },
            use_dummy: false,
            clear_computing_nodes: computingNodes.length === 0,
            force_redeploy: true,
            force: this.relayOverrideRequested(),
        };
    }

    public relayPreflightReady(): boolean {
        return !!this.relayPreflightReport?.ok;
    }

    public relayPreflightForceable(): boolean {
        return !!this.relayPreflightReport?.force_allowed && !(this.relayPreflightReport?.hard_error_count > 0);
    }

    public relayOverrideRequested(): boolean {
        return !this.relayPreflightReady() && this.relayPreflightForceable() && this.relayAllowOverride;
    }

    public relayPreflightStatusLabel(): string {
        if (this.relayPreflightLoading) return '점검 중';
        if (!this.relayPreflightReport) return '미실행';
        if (this.relayPreflightReport.ok) return '통과';
        if (this.relayPreflightForceable()) return 'Override 필요';
        return '실패';
    }

    public relayPreflightBadgeClass(): string {
        if (this.relayPreflightLoading) return 'bg-blue-100 text-blue-700';
        if (!this.relayPreflightReport) return 'bg-slate-100 text-slate-600';
        if (this.relayPreflightReport.ok) return 'bg-emerald-100 text-emerald-700';
        if (this.relayPreflightForceable()) return 'bg-amber-100 text-amber-700';
        return 'bg-rose-100 text-rose-700';
    }

    public relayPreflightSummaryText(): string {
        const summary = this.relayPreflightReport?.summary || {};
        if (!this.relayPreflightReport) return 'Preflight를 실행하면 환경, subnet, relay server, computing node 상태를 확인합니다.';
        return `OK ${summary.ok_count || 0} · Warning ${summary.warning_count || 0} · Error ${summary.error_count || 0}`;
    }

    private beginRelayDiagnostic(action: string, message: string = '') {
        this.relayDiagnosticVisible = true;
        this.relayDiagnosticExpanded = true;
        this.relayDiagnosticAction = action === 'deploy' ? 'deploy' : 'precheck';
        this.relayDiagnosticStartedAt = new Date().toISOString();
        this.relayDiagnosticMessage = message;
        this.relayDiagnosticCode = '';
    }

    private setRelayDiagnosticMessage(message: any, code: any = '') {
        this.relayDiagnosticVisible = true;
        this.relayDiagnosticMessage = String(message || '').trim();
        this.relayDiagnosticCode = String(code || '').trim();
    }

    public toggleRelayDiagnostic() {
        this.relayDiagnosticExpanded = !this.relayDiagnosticExpanded;
        this.service.render();
    }

    public relayDiagnosticActionLabel(): string {
        return this.relayDiagnosticAction === 'deploy' ? '배포 실행' : 'Pre-check';
    }

    public relayDiagnosticStatusLabel(): string {
        if (this.relayPreflightLoading) return 'Preflight 실행 중';
        if (this.relayDeployStarting) return 'Orchestration 시작 중';
        const jobStatus = this.normalizedStatus(this.relayOrchestrationJob?.status);
        if (this.relayDiagnosticAction === 'deploy' && jobStatus) return this.relayJobStatusLabel();
        if (this.relayPreflightReport) return this.relayPreflightStatusLabel();
        return this.relayDiagnosticCode ? '요청 오류' : '준비 중';
    }

    public relayDiagnosticStatusClass(): string {
        if (this.relayPreflightLoading || this.relayDeployStarting) return 'bg-blue-100 text-blue-700';
        const jobStatus = this.normalizedStatus(this.relayOrchestrationJob?.status);
        if (this.relayDiagnosticAction === 'deploy' && jobStatus) return this.logStatusClass(jobStatus);
        if (this.relayPreflightReport) return this.relayPreflightBadgeClass();
        return this.relayDiagnosticCode ? 'bg-rose-100 text-rose-700' : 'bg-slate-100 text-slate-600';
    }

    public relayDiagnosticCheckClass(status: any): string {
        const normalized = this.normalizedStatus(status);
        if (['ok', 'pass', 'passed', 'completed', 'success'].includes(normalized)) return 'bg-emerald-100 text-emerald-700';
        if (['warning', 'warn', 'override'].includes(normalized)) return 'bg-amber-100 text-amber-800';
        if (['running', 'in_progress', 'pending'].includes(normalized)) return 'bg-blue-100 text-blue-700';
        return 'bg-rose-100 text-rose-700';
    }

    public relayDiagnosticIssues(): any[] {
        const sections = [
            { key: 'environment', title: 'Environment' },
            { key: 'subnets', title: 'Subnet / DHCP / TFTP' },
            { key: 'relay_servers', title: 'Relay Server' },
            { key: 'computing_nodes', title: 'Compute Node' },
        ];
        const issues: any[] = [];
        for (const section of sections) {
            for (const item of this.relayPreflightReport?.[section.key] || []) {
                for (const check of item?.checks || []) {
                    if (['ok', 'pass', 'passed', 'success'].includes(this.normalizedStatus(check?.status))) continue;
                    issues.push({
                        section: section.title,
                        item: item?.name || item?.title || item?.id || '-',
                        status: check?.status || item?.status || 'error',
                        title: check?.title || '상세 확인 필요',
                        detail: check?.detail || '',
                        value: check?.value || '',
                        code: check?.code || '',
                    });
                }
            }
        }
        return issues;
    }

    public relayDiagnosticFailedNodes(): any[] {
        const reportRows = Array.isArray(this.relayPreflightReport?.failed_nodes) ? this.relayPreflightReport.failed_nodes : [];
        const jobRows = Array.isArray(this.relayOrchestrationJob?.failed_nodes) ? this.relayOrchestrationJob.failed_nodes : [];
        return [...reportRows, ...jobRows];
    }

    public relayDiagnosticStageEvents(): any[] {
        const reportRows = Array.isArray(this.relayPreflightReport?.stage_events) ? this.relayPreflightReport.stage_events : [];
        const jobRows = Array.isArray(this.relayOrchestrationJob?.stage_events) ? this.relayOrchestrationJob.stage_events : [];
        return [...reportRows, ...jobRows].slice(-20);
    }

    public relayDiagnosticRollbackHints(): any[] {
        return Array.isArray(this.relayPreflightReport?.rollback_hints) ? this.relayPreflightReport.rollback_hints : [];
    }

    public relayCanStartDeploy(relayServers: any[] = this.targetRelayServers(), computingNodes: any[] = this.targetComputeNodes()): boolean {
        return !!this.relayForm.relay_image_id &&
            !!this.relayForm.computing_image_id &&
            relayServers.length > 0 &&
            computingNodes.length > 0 &&
            !this.relayPreflightLoading &&
            !this.relayDeployStarting &&
            (this.relayPreflightReady() || this.relayOverrideRequested());
    }

    public async deployRelayServers(targetRelayServers: any[] = this.targetRelayServers()) {
        if (this.deploymentActionBusy()) return;
        this.beginRelayDiagnostic('deploy', 'Relay server 단독 배포 요청을 확인하고 있습니다.');
        if (!this.deploymentOptionsLoaded) await this.loadDeploymentOptions(false);
        const imageId = Number(this.relayForm.relay_image_id || 0);
        const relayServers = Array.isArray(targetRelayServers) ? targetRelayServers : this.targetRelayServers();
        if (!imageId) {
            this.relayMessage = 'Relay server 이미지를 선택하세요.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-image-selection');
            await this.service.render();
            return;
        }
        if (relayServers.length === 0) {
            this.relayMessage = '배포 대상 relay server가 없습니다.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-target-selection');
            await this.service.render();
            return;
        }

        this.relayServerDeploying = true;
        this.relayMessage = '';
        await this.service.render();
        try {
            const failures: string[] = [];
            for (const server of relayServers) {
                const { code, data } = await this.relayApi('deploy_server', {
                    node_id: server.id,
                    image_id: imageId,
                });
                if (code !== 200) failures.push(`${server.name || server.id}: ${data?.message || 'Deploy failed.'}`);
            }
            const message = failures.length > 0
                ? failures.join('; ')
                : `${relayServers.length}개 relay server 배포 작업을 큐에 등록했습니다.`;
            await this.load();
            this.relayMessage = message;
            this.setRelayDiagnosticMessage(message, failures.length > 0 ? 'relay-server-deploy-failed' : '');
        } finally {
            this.relayServerDeploying = false;
            await this.service.render();
        }
    }

    public async runRelayPreflight(shouldRender: boolean = true, relayServers: any[] = this.targetRelayServers(), computingNodes: any[] = this.targetComputeNodes(), executionMode: string = 'scope', diagnosticAction: string = 'precheck') {
        this.beginRelayDiagnostic(diagnosticAction, diagnosticAction === 'deploy' ? '배포 전 Preflight를 실행하고 있습니다.' : 'Preflight를 실행하고 있습니다.');
        if (!this.deploymentOptionsLoaded) await this.loadDeploymentOptions(false);
        if (!this.relayForm.relay_image_id || !this.relayForm.computing_image_id) {
            this.relayMessage = 'Relay server 이미지와 computing 이미지를 선택하세요.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-image-selection');
            if (shouldRender) await this.service.render();
            return;
        }
        if (relayServers.length === 0) {
            this.relayMessage = 'Preflight 대상 relay server가 없습니다.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-target-selection');
            if (shouldRender) await this.service.render();
            return;
        }
        if (computingNodes.length === 0) {
            this.relayMessage = 'Preflight 대상 computing node가 없습니다.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-target-selection');
            if (shouldRender) await this.service.render();
            return;
        }

        this.relayPreflightLoading = true;
        this.relayMessage = '';
        if (shouldRender) await this.service.render();
        const request = this.relayApi('preflight', { data: JSON.stringify(this.buildClusterRelayRequestPayload('', relayServers, computingNodes, executionMode)) });
        const timeout = new Promise(resolve => setTimeout(() => resolve({
            code: 408,
            data: { message: 'Relay preflight timed out.' },
        }), 45000));
        const { code, data }: any = await Promise.race([request, timeout]);
        this.relayPreflightLoading = false;
        if (code === 200) {
            this.relayPreflightReport = data;
        } else {
            this.relayPreflightReport = data?.report || {
                ok: false,
                checked_at: new Date().toISOString(),
                verdict: 'fail',
                deploy_message: data?.message || 'Relay preflight failed.',
                summary: { ok_count: 0, warning_count: 0, error_count: 1 },
            };
        }
        this.setRelayDiagnosticMessage(
            this.relayPreflightReport?.deploy_message || data?.message || (this.relayPreflightReport?.ok ? 'Preflight를 통과했습니다.' : 'Preflight 실패 항목을 확인하세요.'),
            code === 200 ? '' : `preflight-http-${code || 0}`,
        );
        if (!this.relayPreflightForceable()) this.relayAllowOverride = false;
        if (shouldRender) await this.service.render();
    }

    public async startRelayDeployment(targets: any = null) {
        if (this.deploymentActionBusy()) return;
        this.beginRelayDiagnostic('deploy', '배포 대상과 Preflight 상태를 확인하고 있습니다.');
        await this.service.render();
        if (!this.deploymentOptionsLoaded) await this.loadDeploymentOptions(false);
        const relayServers = Array.isArray(targets?.relayServers) ? targets.relayServers : this.targetRelayServers();
        const computingNodes = Array.isArray(targets?.computingNodes) ? targets.computingNodes : this.targetComputeNodes();
        const executionMode = String(targets?.executionMode || (targets ? 'selected' : (this.deploymentScope === 'group' ? 'group' : 'cluster')));
        if (targets) {
            this.relayPreflightReport = null;
            this.relayAllowOverride = false;
        }
        if (!this.relayPreflightReady() && !this.relayOverrideRequested()) {
            await this.runRelayPreflight(false, relayServers, computingNodes, executionMode, 'deploy');
            if (!this.relayPreflightReady() && !this.relayOverrideRequested()) {
                this.relayMessage = this.relayPreflightForceable()
                    ? 'Preflight override 확인 후 다시 실행하세요.'
                    : 'Preflight 실패 항목을 먼저 해결해야 합니다.';
                this.setRelayDiagnosticMessage(this.relayMessage, 'preflight-blocked');
                await this.service.render();
                return;
            }
        }
        if (!this.relayCanStartDeploy(relayServers, computingNodes)) {
            this.relayMessage = '배포 시작 조건을 확인하세요.';
            this.setRelayDiagnosticMessage(this.relayMessage, 'client-start-condition');
            await this.service.render();
            return;
        }

        this.relayDeployStarting = true;
        this.relayMessage = '';
        await this.service.render();
        try {
            const payload = this.buildClusterRelayRequestPayload('', relayServers, computingNodes, executionMode);
            const { code, data } = await this.relayApi('orchestration_start', {
                data: JSON.stringify(payload),
            });
            if ((code === 200 || code === 409) && data?.job) {
                if (data?.group_id) this.relayCreatedId = String(data.group_id);
                this.syncRelayOrchestrationJob(data.job);
                this.relayMessage = code === 409 ? (data?.message || '이미 실행 중인 relay orchestration이 있습니다.') : 'Relay orchestration을 시작했습니다.';
                this.setRelayDiagnosticMessage(this.relayMessage, code === 409 ? 'orchestration-already-running' : '');
                this.startRelayJobPoll();
            } else {
                if (data?.report) this.relayPreflightReport = data.report;
                this.relayMessage = data?.message || 'Relay orchestration 시작에 실패했습니다.';
                this.setRelayDiagnosticMessage(this.relayMessage, `orchestration-http-${code || 0}`);
            }
        } finally {
            this.relayDeployStarting = false;
            await this.service.render();
        }
    }

    private relayJobInProgress(job: any): boolean {
        return ['pending', 'running'].includes(String(job?.status || '').toLowerCase());
    }

    private syncRelayOrchestrationJob(job: any) {
        this.relayOrchestrationJob = job || null;
        this.relayOrchestrationJobId = String(job?.id || this.relayOrchestrationJobId || '');
        if (this.relayDiagnosticVisible && this.relayDiagnosticAction === 'deploy' && job) {
            const failedStep = (job?.steps || []).find((step: any) => this.normalizedStatus(step?.status) === 'failed');
            if (this.normalizedStatus(job?.status) === 'failed') {
                this.setRelayDiagnosticMessage(job?.message || failedStep?.message || 'Relay orchestration이 실패했습니다.', failedStep?.key || 'orchestration-failed');
            } else if (job?.message) {
                this.setRelayDiagnosticMessage(job.message);
            }
        }
        if (this.orchestrationErrorModalOpen && this.orchestrationErrorStep) {
            const stepKey = String(this.orchestrationErrorStep?.key || '');
            const currentStep = (job?.steps || []).find((step: any) => String(step?.key || '') === stepKey)
                || this.orchestrationErrorStep;
            this.orchestrationErrorStep = { ...currentStep };
            this.orchestrationErrorRows = this.orchestrationStepErrorRows(currentStep);
        }
    }

    private async refreshRelayOrchestrationJob(shouldRender: boolean = true) {
        if (!this.relayCreatedId && !this.relayOrchestrationJobId) return;
        const result = this.relayCreatedId
            ? await this.relayApi('latest_orchestration', { group_id: this.relayCreatedId })
            : await this.relayApi('orchestration_status', { job_id: this.relayOrchestrationJobId });
        if (result?.code === 200 && result.data?.job) {
            this.syncRelayOrchestrationJob(result.data.job);
            if (this.relayJobInProgress(result.data.job)) this.startRelayJobPoll();
        }
        if (shouldRender) await this.service.render();
    }

    private startRelayJobPoll() {
        if (this.relayJobPoller) clearInterval(this.relayJobPoller);
        if (!this.relayOrchestrationJobId && !this.relayCreatedId) return;
        this.relayJobPoller = setInterval(async () => {
            let result: any = null;
            if (this.relayCreatedId) {
                result = await this.relayApi('latest_orchestration', { group_id: this.relayCreatedId });
            } else {
                result = await this.relayApi('orchestration_status', { job_id: this.relayOrchestrationJobId });
            }
            if (result?.code === 200 && result.data?.job) {
                this.syncRelayOrchestrationJob(result.data.job);
                if (!this.relayJobInProgress(result.data.job) && this.relayJobPoller) {
                    clearInterval(this.relayJobPoller);
                    this.relayJobPoller = null;
                    await this.load();
                }
                await this.service.render();
            }
        }, 10000);
    }

    public relayJobStatusLabel(): string {
        const status = String(this.relayOrchestrationJob?.status || '').trim();
        if (!status) return '대기';
        if (status === 'completed') return '완료';
        if (status === 'failed') return '실패';
        if (status === 'running') return '실행 중';
        if (status === 'pending') return '대기 중';
        return status;
    }

    public relayJobSteps(): any[] {
        return this.relayOrchestrationJob?.steps || [];
    }

    public directStatusRows(stats: any = this.deployStats()): any[] {
        stats = stats || this.deployStats();
        return [
            { key: 'deployed', label: '배포 완료', count: stats.deployed, desc: 'OS 이미지 배포 및 초기 설정 완료' },
            { key: 'in_progress', label: '배포 중', count: stats.in_progress, desc: 'OS 이미지 배포 및 설정 진행 중' },
            { key: 'pending', label: '배포 대기', count: stats.pending, desc: '배포 대기 상태' },
            { key: 'failed', label: '배포 실패', count: stats.failed, desc: '배포 실패 (재시도 필요)' },
        ];
    }

    public statusRowPercent(row: any, stats: any = this.deployStats()): number {
        const total = Math.max(1, Number((stats || this.deployStats()).total || 0));
        return Math.round((Number(row?.count || 0) / total) * 1000) / 10;
    }

    public statusRowTextClass(key: string): string {
        if (key === 'deployed') return 'text-emerald-600';
        if (key === 'in_progress') return 'text-blue-600';
        if (key === 'failed') return 'text-rose-600';
        return 'text-slate-600';
    }

    public statusRowBarClass(key: string): string {
        if (key === 'deployed') return 'bg-emerald-500';
        if (key === 'in_progress') return 'bg-blue-600';
        if (key === 'failed') return 'bg-rose-600';
        return 'bg-slate-300';
    }

    public legendItems(): any[] {
        return [
            { key: 'completed', title: '배포 완료', desc: '정상적으로 배포가 완료됨' },
            { key: 'deploying', title: '배포 중', desc: '배포 작업이 진행 중' },
            { key: 'partial', title: '일부 배포', desc: '일부 노드에 배포 완료' },
            { key: 'pending', title: '대기', desc: '배포 대기 상태' },
            { key: 'failed', title: '배포 실패', desc: '배포에 실패함' },
        ];
    }

    public monitoringTargets(): any[] {
        const source = this.isRelayDeployment()
            ? [...this.activeRelayNodes(), ...this.computeNodes()]
            : (this.nodes || []);
        const seen: any = {};
        return source.filter((node: any) => {
            const key = String(node?.id || node?.name || '');
            if (!key) return false;
            if (seen[key]) return false;
            seen[key] = true;
            return !node?.cluster_relay_excluded && !node?.cluster_relay_unassigned;
        });
    }

    private monitoringReady(node: any): boolean {
        const status = `${this.normalizedStatus(node?.status)} ${this.normalizedStatus(node?.deploy_status)} ${this.normalizedStatus(node?.cluster_deploy_status)}`;
        return status.includes('ready')
            || status.includes('active')
            || status.includes('deployed')
            || status.includes('commissioned')
            || this.nodeDeployBucket(node) === 'deployed';
    }

    private monitoringIssue(node: any): boolean {
        const status = `${this.normalizedStatus(node?.status)} ${this.normalizedStatus(node?.deploy_status)} ${this.normalizedStatus(node?.cluster_deploy_status)}`;
        return status.includes('fail') || status.includes('error') || status.includes('critical') || this.nodeDeployBucket(node) === 'failed';
    }

    public monitoringStats(): any {
        const targets = this.monitoringTargets();
        const powerOn = targets.filter((node: any) => this.normalizedStatus(node?.power_status) === 'on').length;
        const ready = targets.filter((node: any) => this.monitoringReady(node)).length;
        const issue = targets.filter((node: any) => this.monitoringIssue(node)).length;
        const checkin = targets.filter((node: any) => String(node?.last_checkin || '').trim()).length;
        return {
            total: targets.length,
            relay: targets.filter((node: any) => this.isRelayNode(node)).length,
            compute: targets.filter((node: any) => !this.isRelayNode(node)).length,
            powerOn,
            ready,
            issue,
            checkin,
        };
    }

    public monitoringCards(): any[] {
        const stats = this.monitoringStats();
        return [
            {
                label: 'Monitoring Targets',
                value: this.formatNumber(stats.total),
                sub: `Relay ${this.formatNumber(stats.relay)} / Compute ${this.formatNumber(stats.compute)}`,
                icon: 'bx bx-server',
                className: 'text-slate-900',
            },
            {
                label: 'Power On',
                value: this.formatNumber(stats.powerOn),
                sub: `${this.formatNumber(stats.total - stats.powerOn)} powered off`,
                icon: 'bx bx-power-off',
                className: 'text-emerald-600',
            },
            {
                label: 'Ready',
                value: this.formatNumber(stats.ready),
                sub: `${this.formatNumber(stats.checkin)} check-in recorded`,
                icon: 'bx bx-check-circle',
                className: 'text-blue-600',
            },
            {
                label: 'Issue',
                value: this.formatNumber(stats.issue),
                sub: 'Failed or error state',
                icon: 'bx bx-error-circle',
                className: 'text-rose-600',
            },
        ];
    }

    public monitoringClusterInfoRows(): any[] {
        const stats = this.monitoringStats();
        return [
            { label: '클러스터', value: this.item?.name || '-' },
            { label: '클러스터 ID', value: this.item?.cluster_uid || this.item?.id || '-' },
            { label: '배포 구조', value: this.deploymentTypeLabel() },
            { label: '모니터링 대상', value: `${this.formatNumber(stats.total)} nodes` },
            { label: '최근 배포', value: this.latestDeployAt() ? this.formatDateTime(this.latestDeployAt()) : '-' },
            { label: '생성자', value: this.creatorLabel() },
        ];
    }

    public zabbixConfig(): any {
        return this.item?.zabbix_config || {};
    }

    private booleanLike(value: any): boolean {
        if (typeof value === 'boolean') return value;
        const text = String(value || '').trim().toLowerCase();
        return !['', '0', 'false', 'no', 'off', 'disabled'].includes(text);
    }

    public zabbixAgentPolicyLabel(): string {
        const enabled = this.configValue(['deployment_options.post_deploy_zabbix_agent', 'post_deploy_zabbix_agent', 'zabbix.agent'], this.postDeployZabbixAgent);
        return this.booleanLike(enabled) ? 'Enabled' : 'Manual';
    }

    public zabbixProxyPolicyLabel(): string {
        const enabled = this.configValue(['deployment_options.post_deploy_zabbix_proxy', 'post_deploy_zabbix_proxy', 'zabbix.proxy'], this.postDeployZabbixProxy);
        if (!this.isRelayDeployment()) return 'Direct';
        return this.booleanLike(enabled) ? 'Enabled' : 'Manual';
    }

    public zabbixConfigRows(): any[] {
        const config = this.zabbixConfig();
        return [
            { label: 'Zabbix Server', value: config.url || '미설정' },
            { label: 'Proxy Route', value: config.embed_url || '/kiera/monitor-proxy/index.php' },
            { label: 'Login User', value: config.username || 'Admin' },
            { label: 'Agent Policy', value: this.zabbixAgentPolicyLabel() },
            { label: this.isRelayDeployment() ? 'Proxy Policy' : 'Direct Path', value: this.zabbixProxyPolicyLabel() },
            { label: 'Target Scope', value: this.isRelayDeployment() ? 'Relay + Compute nodes' : 'Compute nodes' },
        ];
    }

    public zabbixStatusCards(): any[] {
        const config = this.zabbixConfig();
        return [
            {
                label: 'Server',
                value: config.url ? 'Configured' : 'Not Set',
                sub: config.url || '-',
                className: config.url ? 'text-emerald-600' : 'text-slate-500',
                icon: config.url ? 'bx bx-check-circle' : 'bx bx-info-circle',
            },
            {
                label: 'Agent',
                value: this.zabbixAgentPolicyLabel(),
                sub: `${this.formatNumber(this.monitoringStats().ready)} ready targets`,
                className: this.zabbixAgentPolicyLabel() === 'Enabled' ? 'text-blue-600' : 'text-slate-500',
                icon: 'bx bx-pulse',
            },
            {
                label: this.isRelayDeployment() ? 'Proxy' : 'Path',
                value: this.zabbixProxyPolicyLabel(),
                sub: this.isRelayDeployment() ? `${this.formatNumber(this.activeRelayNodes().length)} relay servers` : 'Main server -> compute nodes',
                className: this.zabbixProxyPolicyLabel() === 'Enabled' ? 'text-indigo-600' : 'text-slate-500',
                icon: this.isRelayDeployment() ? 'bx bx-git-branch' : 'bx bx-right-arrow-alt',
            },
        ];
    }

    public monitoringRows(): any[] {
        return this.monitoringTargets().slice(0, 100);
    }

    public monitoringStateKey(node: any): string {
        const status = `${this.normalizedStatus(node?.status)} ${this.normalizedStatus(node?.deploy_status)} ${this.normalizedStatus(node?.cluster_deploy_status)}`;
        if (this.monitoringIssue(node)) return 'issue';
        if (this.nodeReadyIdle(node)) return 'ready';
        if (status.includes('commission')) return 'commissioning';
        if (status.includes('deploy') || status.includes('running') || this.nodeDeployBucket(node) === 'in_progress') return 'deploying';
        if (this.monitoringReady(node)) return 'ready';
        return 'pending';
    }

    public monitoringStateLabel(node: any): string {
        const key = this.monitoringStateKey(node);
        if (key === 'ready') return 'ready';
        if (key === 'deploying') return 'deploying';
        if (key === 'commissioning') return 'commissioning';
        if (key === 'issue') return 'issue';
        return 'pending';
    }

    public monitoringStateClass(node: any): string {
        const key = this.monitoringStateKey(node);
        if (key === 'ready') return 'bg-emerald-100 text-emerald-700';
        if (key === 'deploying') return 'bg-blue-100 text-blue-700';
        if (key === 'commissioning') return 'bg-slate-100 text-slate-700';
        if (key === 'issue') return 'bg-rose-100 text-rose-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public monitoringAgentLabel(node: any): string {
        const key = this.monitoringStateKey(node);
        if (key === 'ready') return 'Active';
        if (key === 'issue') return 'Issue';
        if (key === 'deploying' || key === 'commissioning') return 'Pending';
        return this.zabbixAgentPolicyLabel() === 'Enabled' ? 'Waiting' : 'Manual';
    }

    public monitoringAgentClass(node: any): string {
        const label = this.monitoringAgentLabel(node).toLowerCase();
        if (label === 'active') return 'bg-emerald-100 text-emerald-700';
        if (label === 'issue') return 'bg-rose-100 text-rose-700';
        if (label === 'pending') return 'bg-blue-100 text-blue-700';
        return 'bg-slate-100 text-slate-600';
    }

    public monitoringProxyLabel(node: any): string {
        if (!this.isRelayDeployment()) return 'Direct';
        if (this.isRelayNode(node)) return String(node?.cluster_relay_role || '').toLowerCase() === 'authority' ? 'Proxy Authority' : 'Proxy Member';
        return node?.cluster_relay_id ? 'Via Relay' : 'Unassigned';
    }

    public monitoringProxyClass(node: any): string {
        const label = this.monitoringProxyLabel(node).toLowerCase();
        if (label.includes('authority')) return 'bg-indigo-100 text-indigo-700';
        if (label.includes('member') || label.includes('via')) return 'bg-blue-100 text-blue-700';
        if (label.includes('unassigned')) return 'bg-amber-100 text-amber-700';
        return 'bg-slate-100 text-slate-600';
    }

    public monitoringCheckInLabel(node: any): string {
        return node?.last_checkin ? this.formatDateTime(node.last_checkin) : '-';
    }

    public monitoringActionItems(): any[] {
        return [
            { key: 'open-zabbix', label: 'Zabbix 열기', icon: 'bx bx-link-external', primary: true },
            { key: 'refresh', label: '상태 새로고침', icon: 'bx bx-refresh' },
            { key: 'cluster-zabbix', label: '노드 Zabbix', icon: 'bx bx-pulse' },
            { key: 'nodes', label: '노드 목록', icon: 'bx bx-server' },
            { key: 'deployment', label: 'Deployment', icon: 'bx bx-layer' },
            { key: 'logs', label: 'Logs', icon: 'bx bx-file' },
        ];
    }

    public async runMonitoringAction(action: string) {
        this.monitoringActionMessage = '';
        if (action === 'open-zabbix') {
            this.openZabbixConsole();
            return;
        }
        if (action === 'refresh') {
            await this.refresh();
            return;
        }
        if (action === 'cluster-zabbix') {
            this.openClusterManagement('zabbix');
            return;
        }
        if (action === 'nodes') {
            this.openClusterManagement('nodes');
            return;
        }
        if (action === 'deployment') {
            this.selectTab('deployment');
            return;
        }
        if (action === 'logs') this.selectTab('logs');
    }

    public openZabbixConsole() {
        this.service.href('/kiera/zabbix');
    }

    public monitoringAdvancedRows(): any[] {
        return [
            { label: 'Agent Install', value: this.zabbixAgentPolicyLabel(), icon: 'bx bx-pulse' },
            { label: 'Proxy Register', value: this.zabbixProxyPolicyLabel(), icon: 'bx bx-git-branch' },
            { label: 'Check-in Source', value: 'node.last_checkin', icon: 'bx bx-time-five' },
            { label: 'Monitoring Route', value: this.zabbixConfig().embed_url || '/kiera/monitor-proxy/index.php', icon: 'bx bx-network-chart' },
            { label: 'Ready Rule', value: 'ready / active / deployed / commissioned', icon: 'bx bx-check-shield' },
            { label: 'Issue Rule', value: 'failed / error / critical', icon: 'bx bx-error-circle' },
        ];
    }

    public nodeRoleLabel(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority') return 'Authority Relay';
        if (role === 'member') return 'Member Relay';
        return 'Compute';
    }

    public nodeStatusLabel(node: any): string {
        const bucket = this.nodeDeployBucket(node);
        if (bucket === 'deployed') return '배포 완료';
        if (bucket === 'in_progress') return '배포 중';
        if (bucket === 'failed') return '배포 실패';
        if (this.nodeReadyIdle(node)) return '준비';
        return '대기';
    }

    private nodesNameSort(left: any, right: any): number {
        return String(left?.name || left?.id || '').localeCompare(
            String(right?.name || right?.id || ''),
            undefined,
            { numeric: true, sensitivity: 'base' },
        );
    }

    private nodesAssignedRelay(node: any, relays: any[] = this.activeRelayNodes()): any {
        if (this.isRelayNode(node)) return null;
        const relayId = String(
            node?.cluster_relay_id
            || node?.relay_server_node_id
            || node?.relay_server_id
            || '',
        ).trim();
        if (!relayId) return null;
        return (relays || []).find((relay: any) => {
            const keys = [
                relay?.id,
                relay?.node_id,
                relay?.cluster_relay_server_row_id,
            ].map((value: any) => String(value || '').trim()).filter((value: string) => !!value);
            return keys.includes(relayId);
        }) || null;
    }

    public nodesInventoryRows(): any[] {
        const relayRows = this.isRelayDeployment()
            ? this.activeRelayNodes()
                .map((node: any) => this.mergeOrchestrationNodeState({ ...node, tree_role: 'relay' }, 'relay'))
                .sort((left: any, right: any) => {
                    const leftRole = String(left?.cluster_relay_role || '').toLowerCase();
                    const rightRole = String(right?.cluster_relay_role || '').toLowerCase();
                    if (leftRole !== rightRole) return leftRole === 'authority' ? -1 : 1;
                    return this.nodesNameSort(left, right);
                })
            : [];
        const computeRows = this.computeNodes()
            .map((node: any) => this.mergeOrchestrationNodeState({ ...node, tree_role: 'compute' }, 'compute'))
            .sort((left: any, right: any) => this.nodesNameSort(left, right));
        if (!this.isRelayDeployment()) {
            return computeRows.map((node: any) => ({ ...node, nodes_level: 0 }));
        }

        const rows: any[] = [];
        const assignedIds = new Set<string>();
        for (const relay of relayRows) {
            rows.push({ ...relay, nodes_level: 0 });
            for (const node of computeRows) {
                const assignedRelay = this.nodesAssignedRelay(node, relayRows);
                if (!assignedRelay || String(assignedRelay.id) !== String(relay.id)) continue;
                rows.push({ ...node, nodes_level: 1 });
                assignedIds.add(String(node.id));
            }
        }
        computeRows
            .filter((node: any) => !assignedIds.has(String(node.id)))
            .forEach((node: any) => rows.push({ ...node, nodes_level: 1 }));
        return rows;
    }

    public nodesRoleKey(node: any): string {
        return this.isRelayNode(node) || String(node?.tree_role || '') === 'relay' ? 'relay' : 'compute';
    }

    public nodesRoleLabel(node: any): string {
        return this.nodesRoleKey(node) === 'relay' ? 'Relay' : 'Compute';
    }

    public nodesRoleMarkerLabel(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority') return 'Authority';
        if (role === 'member') return 'Member';
        return '';
    }

    public nodesRoleMarkerClass(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority') return 'bg-emerald-100 text-emerald-700';
        if (role === 'member') return 'bg-blue-100 text-blue-700';
        return 'bg-slate-100 text-slate-600';
    }

    public nodesDhcpRoleKey(node: any): string {
        const role = String(node?.cluster_relay_role || '').trim().toLowerCase();
        if (role === 'authority' || role === 'member') return role;
        return 'client';
    }

    public nodesDhcpRoleLabel(node: any): string {
        const role = this.nodesDhcpRoleKey(node);
        if (role === 'authority') return 'Authority';
        if (role === 'member') return 'Next Server';
        return 'Client';
    }

    public nodesDhcpRoleClass(node: any): string {
        const role = this.nodesDhcpRoleKey(node);
        if (role === 'authority') return 'bg-emerald-100 text-emerald-700';
        if (role === 'member') return 'bg-indigo-100 text-indigo-700';
        return 'bg-teal-100 text-teal-700';
    }

    public nodesAssignedRelayKey(node: any): string {
        const relay = this.nodesAssignedRelay(node);
        return relay ? String(relay.id) : '__unassigned';
    }

    public nodesAssignedRelayLabel(node: any): string {
        if (this.nodesRoleKey(node) === 'relay') return '-';
        const relay = this.nodesAssignedRelay(node);
        return relay?.name || relay?.ip_address || '-';
    }

    public nodesAssignedRelayOptions(): any[] {
        const computes = this.nodesInventoryRows().filter((node: any) => this.nodesRoleKey(node) === 'compute');
        return this.activeRelayNodes()
            .map((relay: any) => ({
                id: String(relay.id),
                label: relay.name || relay.ip_address || `Relay #${relay.id}`,
                count: computes.filter((node: any) => this.nodesAssignedRelayKey(node) === String(relay.id)).length,
            }))
            .sort((left: any, right: any) => String(left.label).localeCompare(String(right.label), undefined, { numeric: true }));
    }

    private nodesRackKey(node: any): string {
        const rackId = Number(node?.location_rack_id || node?.rack_id || 0);
        if (rackId > 0) return `id:${rackId}`;
        const rack = String(node?.location_rack || node?.rack || '').trim().toLowerCase();
        return rack ? `rack:${rack}` : '__unassigned';
    }

    private nodesRackLabel(node: any): string {
        const value = String(
            node?.location_rack_name
            || node?.location_rack
            || node?.rack
            || '',
        ).trim();
        if (!value) return 'Unassigned';
        return /^rack\s/i.test(value) ? value : `Rack ${value}`;
    }

    public nodesRackOptions(): any[] {
        const options: any = {};
        for (const node of this.nodesInventoryRows()) {
            const key = this.nodesRackKey(node);
            if (!options[key]) options[key] = { value: key, label: this.nodesRackLabel(node), count: 0 };
            options[key].count += 1;
        }
        return Object.values(options).sort((left: any, right: any) => {
            if (left.value === '__unassigned') return 1;
            if (right.value === '__unassigned') return -1;
            return String(left.label).localeCompare(String(right.label), undefined, { numeric: true });
        });
    }

    public nodesLocationLabel(node: any): string {
        const rack = this.nodesRackLabel(node);
        const unit = String(node?.location_unit || node?.unit || '').trim();
        const chassis = String(node?.chassis_name || '').trim();
        const slot = Number(node?.chassis_slot || 0);
        if (chassis) return `${rack} · ${chassis}${slot > 0 ? ` / S${slot}` : ''}`;
        const placement = unit ? `${rack} / ${unit}U` : rack;
        return `${placement} · Standalone`;
    }

    public nodeLifecycleStatusKey(node: any): string {
        const rawStatus = this.normalizedStatus(node?.status);
        const rawDeployStatus = this.normalizedStatus(node?.deploy_status);
        const bucket = this.nodeDeployBucket(node);
        if (bucket === 'failed' || rawStatus === 'failed' || rawStatus.includes('error') || rawDeployStatus.includes('fail')) return 'failed';
        if (bucket === 'in_progress' || ['commissioning', 'deploying'].includes(rawStatus) || rawDeployStatus.includes('deploying')) return 'deploying';
        if (bucket === 'deployed' || ['deployed', 'diskless'].includes(rawStatus)) return 'deployed';
        if (['ready', 'commissioned'].includes(rawStatus)) return 'ready';
        return 'new';
    }

    public nodeLifecycleStatusLabel(node: any): string {
        const status = this.nodeLifecycleStatusKey(node);
        if (status === 'deployed') return 'Deployed';
        if (status === 'deploying') return 'Deploying';
        if (status === 'ready') return 'Ready';
        if (status === 'failed') return 'Failed';
        return 'New';
    }

    public nodeLifecycleStatusClass(node: any): string {
        const status = this.nodeLifecycleStatusKey(node);
        if (status === 'deployed') return 'bg-emerald-100 text-emerald-700';
        if (status === 'deploying') return 'bg-blue-100 text-blue-700';
        if (status === 'ready') return 'bg-cyan-100 text-cyan-700';
        if (status === 'failed') return 'bg-rose-100 text-rose-700';
        return 'bg-slate-100 text-slate-600';
    }

    public nodeLifecycleDotClass(status: string): string {
        if (status === 'deployed') return 'bg-emerald-500';
        if (status === 'deploying') return 'bg-blue-600';
        if (status === 'ready') return 'bg-cyan-500';
        if (status === 'failed') return 'bg-rose-500';
        return 'bg-slate-500';
    }

    private nodesStatusCounts(): any {
        const counts: any = { total: 0, deployed: 0, deploying: 0, ready: 0, new: 0, failed: 0 };
        for (const node of this.nodesInventoryRows()) {
            counts.total += 1;
            counts[this.nodeLifecycleStatusKey(node)] += 1;
        }
        return counts;
    }

    public nodesSummaryItems(): any[] {
        const counts = this.nodesStatusCounts();
        return [
            { key: 'total', label: '전체', count: counts.total, desc: 'Total Nodes', className: 'bg-slate-400' },
            { key: 'deployed', label: 'Deployed', count: counts.deployed, desc: '배포가 완료된 상태', className: 'bg-emerald-500' },
            { key: 'deploying', label: 'Deploying', count: counts.deploying, desc: '배포가 진행 중인 상태', className: 'bg-blue-600' },
            { key: 'ready', label: 'Ready', count: counts.ready, desc: '시운전 완료된 상태', className: 'bg-cyan-500' },
            { key: 'new', label: 'New', count: counts.new, desc: '신규 등록된 상태', className: 'bg-slate-500' },
            { key: 'failed', label: 'Failed', count: counts.failed, desc: '배포 실패 상태', className: 'bg-rose-500' },
        ];
    }

    public nodesStatusCount(status: string): number {
        return Number(this.nodesStatusCounts()[String(status || 'total')] || 0);
    }

    public nodesSummaryDescription(status: string): string {
        const item = this.nodesSummaryItems().find((summary: any) => summary.key === status);
        return item?.desc || '-';
    }

    public nodesOverallProgress(): number {
        const counts = this.nodesStatusCounts();
        return counts.total > 0 ? Math.round((counts.deployed / counts.total) * 100) : 0;
    }

    public nodesStatusPercent(status: string): number {
        const counts = this.nodesStatusCounts();
        return counts.total > 0 ? (Number(counts[status] || 0) / counts.total) * 100 : 0;
    }

    public nodesStatusFilterOptions(): any[] {
        return [
            { value: 'deployed', label: 'Deployed' },
            { value: 'deploying', label: 'Deploying' },
            { value: 'ready', label: 'Ready' },
            { value: 'new', label: 'New' },
            { value: 'failed', label: 'Failed' },
        ];
    }

    public nodesFilteredRows(): any[] {
        const keyword = String(this.nodesFilter.text || '').trim().toLowerCase();
        return this.nodesInventoryRows().filter((node: any) => {
            if (this.nodesFilter.role && this.nodesRoleKey(node) !== this.nodesFilter.role) return false;
            if (this.nodesFilter.dhcp_role && this.nodesDhcpRoleKey(node) !== this.nodesFilter.dhcp_role) return false;
            if (this.nodesFilter.status && this.nodeLifecycleStatusKey(node) !== this.nodesFilter.status) return false;
            if (this.nodesFilter.rack_key && this.nodesRackKey(node) !== this.nodesFilter.rack_key) return false;
            if (this.nodesFilter.assigned_relay_id) {
                if (this.nodesRoleKey(node) !== 'compute') return false;
                if (this.nodesAssignedRelayKey(node) !== this.nodesFilter.assigned_relay_id) return false;
            }
            if (!keyword) return true;
            const haystack = [
                node?.name,
                node?.old_name,
                node?.ip_address,
                node?.chassis_name,
                node?.chassis_model,
                this.nodesLocationLabel(node),
                this.nodesAssignedRelayLabel(node),
            ].map((value: any) => String(value || '').toLowerCase()).join(' ');
            return haystack.includes(keyword);
        });
    }

    private normalizeNodesPage() {
        const pages = Math.max(1, Math.ceil(this.nodesFilteredRows().length / Number(this.nodesPageSize || 25)));
        this.nodesPage = Math.min(pages, Math.max(1, Number(this.nodesPage || 1)));
    }

    public nodesPagedRows(): any[] {
        const page = Math.min(this.nodesTotalPages(), Math.max(1, Number(this.nodesPage || 1)));
        const start = (page - 1) * Number(this.nodesPageSize || 25);
        return this.nodesFilteredRows().slice(start, start + Number(this.nodesPageSize || 25));
    }

    public nodesTotalPages(): number {
        return Math.max(1, Math.ceil(this.nodesFilteredRows().length / Number(this.nodesPageSize || 25)));
    }

    public nodesPageNumbers(): number[] {
        const total = this.nodesTotalPages();
        const current = Math.min(total, Math.max(1, Number(this.nodesPage || 1)));
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages: number[] = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public nodesPageStart(): number {
        if (this.nodesFilteredRows().length === 0) return 0;
        return ((Math.min(this.nodesPage, this.nodesTotalPages()) - 1) * this.nodesPageSize) + 1;
    }

    public nodesPageEnd(): number {
        return Math.min(this.nodesFilteredRows().length, this.nodesPageStart() + this.nodesPageSize - 1);
    }

    public onNodesFilterChanged() {
        this.nodesPage = 1;
        this.service.render();
    }

    public onNodesPageSizeChanged() {
        this.nodesPage = 1;
        this.normalizeNodesPage();
        this.service.render();
    }

    public moveNodesPage(page: number) {
        this.nodesPage = Math.min(this.nodesTotalPages(), Math.max(1, Number(page || 1)));
        this.service.render();
    }

    public clearNodesFilters() {
        this.nodesFilter = { role: '', dhcp_role: '', assigned_relay_id: '', status: '', rack_key: '', text: '' };
        this.nodesPage = 1;
        this.service.render();
    }

    private nodeOrchestrationRuntime(node: any): any {
        const role = this.nodesRoleKey(node) === 'relay' ? 'relay' : 'compute';
        return this.orchestrationNodeMap(role)[String(node?.id || node?.node_id || '').trim()] || null;
    }

    private nodeRelevantOrchestrationSteps(node: any): any[] {
        const keys = this.nodesRoleKey(node) === 'relay'
            ? ['preflight', 'relay-deploy', 'relay-ready']
            : ['preflight', 'compute-pxe-prepare', 'relay-script', 'compute-power-off', 'compute-deploy', 'compute-ready'];
        return keys
            .map((key: string) => this.orchestrationStepByKey(key))
            .filter((step: any) => !!step);
    }

    public nodeDeploymentProgress(node: any): number {
        const status = this.nodeLifecycleStatusKey(node);
        if (status === 'deployed') return 100;
        if (status === 'new' || status === 'ready') return 0;
        const runtime = this.nodeOrchestrationRuntime(node) || {};
        const explicit = Number(runtime.progress_percent ?? runtime.progress ?? node?.progress_percent ?? node?.progress);
        if (Number.isFinite(explicit) && explicit >= 0) {
            const percent = explicit > 0 && explicit <= 1 ? explicit * 100 : explicit;
            return Math.min(100, Math.max(0, Math.round(percent)));
        }
        const steps = this.nodeRelevantOrchestrationSteps(node);
        if (steps.length > 0) {
            let completed = 0;
            for (const step of steps) {
                const stepStatus = this.normalizedStatus(step?.status);
                if (stepStatus === 'completed') completed += 1;
                else if (stepStatus === 'in_progress' || stepStatus === 'running') completed += 0.5;
            }
            return Math.min(99, Math.max(0, Math.round((completed / steps.length) * 100)));
        }
        return status === 'deploying' ? 50 : 0;
    }

    public nodeDeploymentProgressClass(node: any): string {
        const status = this.nodeLifecycleStatusKey(node);
        if (status === 'deployed') return 'bg-emerald-500';
        if (status === 'failed') return 'bg-rose-500';
        if (status === 'ready') return 'bg-cyan-500';
        return 'bg-blue-600';
    }

    public nodeDeploymentStep(node: any): string {
        const runtime = this.nodeOrchestrationRuntime(node) || {};
        const explicit = String(runtime.current_step_label || runtime.step_label || runtime.current_step || '').trim();
        if (explicit) return explicit;
        const steps = this.nodeRelevantOrchestrationSteps(node);
        const current = steps.find((step: any) => ['in_progress', 'running'].includes(this.normalizedStatus(step?.status)))
            || steps.find((step: any) => this.normalizedStatus(step?.status) === 'failed');
        if (current) return current.title || this.orchestrationStepTitle(String(current.key || ''));
        const status = this.nodeLifecycleStatusKey(node);
        if (status === 'deployed') return '완료';
        if (status === 'ready') return '시운전 완료';
        if (status === 'failed') return '배포 실패';
        if (status === 'deploying') return 'OS 설치';
        return '대기';
    }

    public nodeDeploymentStepDetail(node: any): string {
        const runtime = this.nodeOrchestrationRuntime(node) || {};
        return String(runtime.message || node?.orchestration_message || this.nodeDeploymentStep(node) || '').trim();
    }

    private nodeDeploymentStartedAt(node: any): string {
        const runtime = this.nodeOrchestrationRuntime(node) || {};
        const ownStarted = String(
            runtime.started
            || runtime.started_at
            || runtime.deploy_started_at
            || node?.cluster_deploy_started
            || '',
        ).trim();
        if (ownStarted) return ownStarted;
        const status = this.nodeLifecycleStatusKey(node);
        if (['deployed', 'deploying', 'failed'].includes(status)) {
            return String(this.relayOrchestrationJob?.started || this.relayOrchestrationJob?.created || '').trim();
        }
        return '';
    }

    private nodeDeploymentCompletedAt(node: any): string {
        const runtime = this.nodeOrchestrationRuntime(node) || {};
        const ownCompleted = String(
            runtime.completed
            || runtime.completed_at
            || runtime.deploy_completed_at
            || node?.cluster_deploy_completed
            || '',
        ).trim();
        if (ownCompleted) return ownCompleted;
        const status = this.nodeLifecycleStatusKey(node);
        if (['deployed', 'failed'].includes(status)) return String(this.relayOrchestrationJob?.completed || '').trim();
        return '';
    }

    private nodeClockDurationLabel(seconds: number): string {
        if (!Number.isFinite(seconds) || seconds < 0) return '-';
        const total = Math.max(0, Math.round(seconds));
        const hours = Math.floor(total / 3600);
        const minutes = Math.floor((total % 3600) / 60);
        const remain = total % 60;
        return [hours, minutes, remain].map((value: number) => String(value).padStart(2, '0')).join(':');
    }

    public nodeDeploymentElapsedLabel(node: any): string {
        const runtime = this.nodeOrchestrationRuntime(node) || {};
        const completed = this.nodeDeploymentCompletedAt(node);
        const explicit = Number(completed ? runtime.duration_seconds : runtime.elapsed_seconds);
        if (Number.isFinite(explicit) && explicit >= 0) return this.nodeClockDurationLabel(explicit);
        const startedAt = this.parseLogDate(this.nodeDeploymentStartedAt(node));
        if (!startedAt) return '-';
        const completedAt = completed ? this.parseLogDate(completed) : new Date();
        if (!completedAt || completedAt.getTime() < startedAt.getTime()) return '-';
        return this.nodeClockDurationLabel((completedAt.getTime() - startedAt.getTime()) / 1000);
    }

    public nodeDeploymentStartedLabel(node: any): string {
        const started = this.nodeDeploymentStartedAt(node);
        return started ? this.formatDateTime(started) : '-';
    }

    public nodesFailedCount(): number {
        return this.nodesInventoryRows().filter((node: any) => this.nodeLifecycleStatusKey(node) === 'failed').length;
    }

    public prepareFailedNodeRedeploy() {
        const failedNodes = this.nodesInventoryRows().filter((node: any) => this.nodeLifecycleStatusKey(node) === 'failed');
        if (failedNodes.length === 0) return;
        this.selectedNodeIds = {};
        for (const node of failedNodes) {
            this.selectedNodeIds[String(node.id)] = true;
            const relay = this.nodesAssignedRelay(node);
            if (relay?.id) this.selectedNodeIds[String(relay.id)] = true;
        }
        this.deploymentScope = 'cluster';
        const message = `${failedNodes.length}개 실패 노드를 선택했습니다. 이미지와 설정을 확인한 뒤 재배포하세요.`;
        this.deployMessage = this.isRelayDeployment() ? '' : message;
        this.relayMessage = this.isRelayDeployment() ? message : '';
        this.selectTab('deployment');
    }

    private nodesCsvValue(value: any): string {
        const text = String(value ?? '').replace(/"/g, '""');
        return /[",\n\r]/.test(text) ? `"${text}"` : text;
    }

    public async exportNodesCsv() {
        if (this.nodesExporting || this.nodesFilteredRows().length === 0) return;
        this.nodesExporting = true;
        await this.service.render();
        try {
            const columns = [
                { label: 'Node Name', value: (node: any) => node.name || '' },
                { label: 'Role', value: (node: any) => this.nodesRoleLabel(node) },
                { label: 'DHCP Role', value: (node: any) => this.nodesDhcpRoleLabel(node) },
                { label: 'Assigned Relay', value: (node: any) => this.nodesAssignedRelayLabel(node) },
                { label: 'Location', value: (node: any) => this.nodesLocationLabel(node) },
                { label: 'Status', value: (node: any) => this.nodeLifecycleStatusLabel(node) },
                { label: 'Progress', value: (node: any) => `${this.nodeDeploymentProgress(node)}%` },
                { label: 'Step', value: (node: any) => this.nodeDeploymentStep(node) },
                { label: 'Elapsed Time', value: (node: any) => this.nodeDeploymentElapsedLabel(node) },
                { label: 'Started At', value: (node: any) => this.nodeDeploymentStartedLabel(node) },
            ];
            const lines = [
                columns.map((column: any) => this.nodesCsvValue(column.label)).join(','),
                ...this.nodesFilteredRows().map((node: any) => columns.map((column: any) => this.nodesCsvValue(column.value(node))).join(',')),
            ];
            const blob = new Blob([`\ufeff${lines.join('\n')}`], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const clusterName = String(this.item?.name || this.id || 'cluster').replace(/[^a-zA-Z0-9_-]+/g, '-');
            link.href = URL.createObjectURL(blob);
            link.download = `cluster-deployment-${clusterName}-nodes.csv`;
            link.click();
            URL.revokeObjectURL(link.href);
        } finally {
            this.nodesExporting = false;
            await this.service.render();
        }
    }

    public openDeploymentNode(node: any) {
        if (!node?.id) return;
        this.service.href(`/kiera/nodes/${node.id}`);
    }

    public isDeploymentNodeTerminalAvailable(node: any): boolean {
        return this.nodeLifecycleStatusKey(node) === 'deployed';
    }

    public openDeploymentNodeTerminal(node: any) {
        if (!node?.id) return;
        const url = `/kiera/terminal/${node.id}?name=${encodeURIComponent(node.name || `Node #${node.id}`)}`;
        const popup = window.open(url, `terminal_${node.id}`, 'width=980,height=680,menubar=no,toolbar=no,location=no,status=no');
        if (popup) popup.focus();
    }

    public deploymentSummaryCards(): any[] {
        const stats = this.deployStats();
        return [
            { label: '대상 노드', value: this.formatNumber(stats.total), sub: this.isRelayDeployment() ? '계산 노드 기준' : '전체 계산 노드' },
            { label: '배포 완료', value: this.formatNumber(stats.deployed), sub: `${this.progressPercent(stats)}% 완료` },
            { label: '배포 중', value: this.formatNumber(stats.in_progress), sub: '현재 진행 중' },
            { label: '실패', value: this.formatNumber(stats.failed), sub: '재시도 필요' },
        ];
    }

    private logTimestamp(row: any): string {
        return String(row?.completed || row?.started || row?.updated || row?.created || '').trim();
    }

    private parseLogDate(value: any): Date | null {
        const text = String(value || '').trim();
        if (!text) return null;
        const normalized = text.includes('T') ? text : text.replace(' ', 'T');
        const parsed = new Date(normalized.replace(/Z$/, ''));
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    private localDateText(date: Date = new Date()): string {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    private logDurationSeconds(row: any): number {
        const started = this.parseLogDate(row?.started || row?.created);
        const completed = this.parseLogDate(row?.completed || row?.updated);
        if (!started || !completed) return 0;
        return Math.max(0, Math.round((completed.getTime() - started.getTime()) / 1000));
    }

    private durationSecondsLabel(seconds: number): string {
        if (seconds <= 0) return '-';
        if (seconds < 60) return `${seconds}s`;
        const minutes = Math.floor(seconds / 60);
        const remain = seconds % 60;
        if (minutes < 60) return remain ? `${minutes}m ${remain}s` : `${minutes}m`;
        const hours = Math.floor(minutes / 60);
        const minRemain = minutes % 60;
        return minRemain ? `${hours}h ${minRemain}m` : `${hours}h`;
    }

    public logDurationLabel(row: any): string {
        return this.durationSecondsLabel(this.logDurationSeconds(row));
    }

    public percentLabel(count: number, total: number): string {
        if (!total) return '0%';
        return `${Math.round((count / total) * 1000) / 10}%`;
    }

    private logResultBucket(status: any): string {
        const normalized = this.normalizedStatus(status);
        if (!normalized || ['none', 'new', 'idle'].includes(normalized)) return 'pending';
        if (normalized.includes('fail') || normalized.includes('error') || normalized.includes('cancel')) return 'failed';
        if (normalized.includes('warn') || normalized.includes('partial') || normalized.includes('review')) return 'warning';
        if (['pending', 'queued', 'running', 'deploying', 'in_progress', 'in-progress'].includes(normalized)) return 'running';
        if (['completed', 'deployed', 'done', 'success', 'succeeded', 'ready', 'active', 'commissioned'].includes(normalized)) return 'success';
        return 'pending';
    }

    public logResultLabel(rowOrStatus: any): string {
        const bucket = this.logResultBucket(rowOrStatus?.status ?? rowOrStatus);
        if (bucket === 'success') return 'Success';
        if (bucket === 'failed') return 'Failed';
        if (bucket === 'warning') return 'Warning';
        if (bucket === 'running') return 'Running';
        return 'Pending';
    }

    public logResultBadgeClass(rowOrStatus: any): string {
        const bucket = this.logResultBucket(rowOrStatus?.status ?? rowOrStatus);
        if (bucket === 'success') return 'bg-emerald-100 text-emerald-700 ring-1 ring-emerald-200';
        if (bucket === 'failed') return 'bg-rose-100 text-rose-700 ring-1 ring-rose-200';
        if (bucket === 'warning') return 'bg-amber-100 text-amber-700 ring-1 ring-amber-200';
        if (bucket === 'running') return 'bg-blue-100 text-blue-700 ring-1 ring-blue-200';
        return 'bg-slate-100 text-slate-600 ring-1 ring-slate-200';
    }

    public logResultTextClass(rowOrStatus: any): string {
        const bucket = this.logResultBucket(rowOrStatus?.status ?? rowOrStatus);
        if (bucket === 'success') return 'text-emerald-600';
        if (bucket === 'failed') return 'text-rose-600';
        if (bucket === 'warning') return 'text-amber-600';
        if (bucket === 'running') return 'text-blue-600';
        return 'text-slate-500';
    }

    private normalizeDeploymentLog(log: any, index: number): any {
        const status = log?.status || 'pending';
        const id = String(log?.id ? `deploy-${log.id}` : `deploy-${index}`);
        const target = log?.node_name || log?.node_id || log?.target || 'Cluster';
        const method = log?.method || this.deploymentTypeLabel();
        return {
            ...log,
            id,
            source: log?.source || 'deploy',
            type: 'deployment',
            typeLabel: 'Deployment',
            jobId: log?.job_id || log?.deploy_id || (log?.id ? `JOB-${log.id}` : `JOB-${index + 1}`),
            event: log?.event || method || 'Deploy',
            target,
            status,
            started: log?.started || log?.created || '',
            completed: log?.completed || log?.updated || '',
            user: log?.user || log?.created_by || this.creatorLabel(),
            message: log?.message || log?.log || `${target} deployment ${status}`,
            method,
        };
    }

    private deploymentFallbackRows(): any[] {
        return (this.nodes || [])
            .filter((node: any) => this.nodeDeployTime(node))
            .map((node: any, index: number) => ({
                id: `node-${node.id || index}`,
                node_id: node.id,
                node_name: node.name,
                status: node.cluster_deploy_status || node.deploy_status || node.status || 'pending',
                started: node.cluster_deploy_started || this.nodeDeployTime(node),
                completed: node.cluster_deploy_completed || this.nodeDeployTime(node),
                method: this.deploymentTypeLabel(),
                message: `${node.name || node.id || 'Node'} ${this.nodeStatusLabel(node)}`,
            }));
    }

    private normalizeOperationLog(log: any, index: number): any {
        const category = String(log?.category || 'monitoring').toLowerCase() === 'deployment' ? 'deployment' : 'monitoring';
        const id = String(log?.id || `operation-${index}`);
        const event = log?.event || log?.kind || 'Operation';
        const target = log?.target || log?.node_name || log?.node_id || 'Cluster';
        return {
            ...log,
            id,
            source: log?.source || 'operation_task',
            type: category,
            typeLabel: category === 'deployment' ? 'Deployment' : 'Monitoring',
            jobId: log?.operation_id ? `OP-${log.operation_id}` : id,
            event,
            target,
            status: log?.status || 'pending',
            started: log?.started || log?.created || '',
            completed: log?.completed || log?.updated || '',
            user: log?.user || log?.created_by || this.creatorLabel(),
            message: log?.message || `${event} ${log?.status || 'pending'}`,
            method: log?.kind || event,
        };
    }

    private monitoringFallbackRows(): any[] {
        return this.monitoringTargets().map((node: any, index: number) => {
            const state = this.monitoringStateKey(node);
            const status = state === 'ready' ? 'success' : (state === 'issue' ? 'failed' : (state === 'deploying' ? 'running' : 'pending'));
            return this.normalizeOperationLog({
                id: `monitor-${node.id || index}`,
                category: 'monitoring',
                event: state === 'issue' ? 'Monitoring Issue' : 'Monitoring Snapshot',
                target: node.name || node.ip_address || node.id || 'Node',
                node_id: node.id,
                node_name: node.name,
                status,
                started: node.last_checkin || this.nodeDeployTime(node) || this.item?.updated || this.item?.created,
                completed: node.last_checkin || '',
                user: 'System',
                message: `${this.monitoringStateLabel(node)} / ${this.monitoringAgentLabel(node)} / ${this.monitoringProxyLabel(node)}`,
            }, index);
        });
    }

    private allDeploymentLogRows(): any[] {
        const deployRows = (this.deployLogs.length > 0 ? this.deployLogs : this.deploymentFallbackRows())
            .map((row: any, index: number) => this.normalizeDeploymentLog(row, index));
        const operationRows = (this.operationLogs || [])
            .map((row: any, index: number) => this.normalizeOperationLog(row, index))
            .filter((row: any) => row.type === 'deployment');
        return [...deployRows, ...operationRows].sort((a: any, b: any) => this.logTimestamp(b).localeCompare(this.logTimestamp(a)));
    }

    private allMonitoringLogRows(): any[] {
        const operationRows = (this.operationLogs || [])
            .map((row: any, index: number) => this.normalizeOperationLog(row, index))
            .filter((row: any) => row.type === 'monitoring');
        const rows = operationRows.length > 0 ? operationRows : this.monitoringFallbackRows();
        return rows.sort((a: any, b: any) => this.logTimestamp(b).localeCompare(this.logTimestamp(a)));
    }

    public logSummaryCards(): any[] {
        const deployments = this.allDeploymentLogRows();
        const monitoring = this.allMonitoringLogRows();
        const allRows = [...deployments, ...monitoring];
        const total = allRows.length;
        const failed = allRows.filter((row: any) => this.logResultBucket(row.status) === 'failed').length;
        const warning = allRows.filter((row: any) => this.logResultBucket(row.status) === 'warning').length;
        return [
            { label: 'Total Jobs / Events', value: this.formatNumber(total), sub: 'All time', icon: 'bx bx-file-blank', color: 'blue' },
            { label: 'Deployment Jobs', value: this.formatNumber(deployments.length), sub: this.percentLabel(deployments.length, total), icon: 'bx bx-rocket', color: 'emerald' },
            { label: 'Monitoring Events', value: this.formatNumber(monitoring.length), sub: this.percentLabel(monitoring.length, total), icon: 'bx bx-pulse', color: 'violet' },
            { label: 'Failed', value: this.formatNumber(failed), sub: this.percentLabel(failed, total), icon: 'bx bx-x-circle', color: 'rose' },
            { label: 'Warning', value: this.formatNumber(warning), sub: this.percentLabel(warning, total), icon: 'bx bx-error', color: 'amber' },
        ];
    }

    public logCardIconClass(card: any): string {
        if (card?.color === 'emerald') return 'bg-emerald-100 text-emerald-600';
        if (card?.color === 'violet') return 'bg-violet-100 text-violet-600';
        if (card?.color === 'rose') return 'bg-rose-100 text-rose-600';
        if (card?.color === 'amber') return 'bg-amber-100 text-amber-600';
        return 'bg-blue-100 text-blue-600';
    }

    public logUserOptions(): string[] {
        const users = new Set<string>();
        this.allLogRows(false).forEach((row: any) => {
            const user = String(row.user || '').trim();
            if (user) users.add(user);
        });
        return Array.from(users).sort();
    }

    public resetLogFilters() {
        this.logTimeRange = 'all';
        this.logTypeFilter = 'all';
        this.logResultFilter = 'all';
        this.logUserFilter = 'all';
        this.logSearchText = '';
        this.selectedLogId = '';
        this.service.render();
    }

    public applyLogFilters() {
        this.selectedLogId = '';
        this.service.render();
    }

    private logMatchesTime(row: any): boolean {
        if (this.logTimeRange === 'all') return true;
        const timestamp = this.logTimestamp(row);
        if (!timestamp) return true;
        if (this.logTimeRange === 'today') return this.datePart(timestamp) === this.localDateText();
        if (this.logTimeRange === '7d') {
            const parsed = this.parseLogDate(timestamp);
            if (!parsed) return true;
            return parsed.getTime() >= Date.now() - (7 * 24 * 60 * 60 * 1000);
        }
        return true;
    }

    private logMatchesFilters(row: any): boolean {
        if (!this.logMatchesTime(row)) return false;
        if (this.logTypeFilter !== 'all' && row.type !== this.logTypeFilter) return false;
        if (this.logResultFilter !== 'all' && this.logResultBucket(row.status) !== this.logResultFilter) return false;
        if (this.logUserFilter !== 'all' && String(row.user || '') !== this.logUserFilter) return false;
        const keyword = String(this.logSearchText || '').trim().toLowerCase();
        if (!keyword) return true;
        const haystack = [
            row.jobId,
            row.event,
            row.target,
            row.node_name,
            row.node_id,
            row.method,
            row.message,
            row.trace_id,
            row.related_id,
        ].map((value: any) => String(value || '').toLowerCase()).join(' ');
        return haystack.includes(keyword);
    }

    public deploymentJobRows(applyFilters: boolean = true): any[] {
        const rows = this.allDeploymentLogRows();
        return applyFilters ? rows.filter((row: any) => this.logMatchesFilters(row)) : rows;
    }

    public monitoringEventRows(applyFilters: boolean = true): any[] {
        const rows = this.allMonitoringLogRows();
        return applyFilters ? rows.filter((row: any) => this.logMatchesFilters(row)) : rows;
    }

    public allLogRows(applyFilters: boolean = true): any[] {
        const rows = [...this.allDeploymentLogRows(), ...this.allMonitoringLogRows()]
            .sort((a: any, b: any) => this.logTimestamp(b).localeCompare(this.logTimestamp(a)));
        return applyFilters ? rows.filter((row: any) => this.logMatchesFilters(row)) : rows;
    }

    public logRows(): any[] {
        return this.allLogRows();
    }

    public selectLogRow(row: any) {
        this.selectedLogId = String(row?.id || '');
        this.service.render();
    }

    public selectedLogRow(): any {
        const rows = this.allLogRows();
        if (this.selectedLogId) {
            const selected = rows.find((row: any) => String(row.id) === String(this.selectedLogId));
            if (selected) return selected;
        }
        return rows.find((row: any) => ['failed', 'warning'].includes(this.logResultBucket(row.status))) || rows[0] || null;
    }

    public logRowClass(row: any): string {
        return String(row?.id || '') === String(this.selectedLogRow()?.id || '')
            ? 'bg-indigo-50'
            : 'hover:bg-slate-50';
    }

    public logExecutionSummary(): any {
        const rows = this.allLogRows();
        const total = rows.length;
        const success = rows.filter((row: any) => this.logResultBucket(row.status) === 'success').length;
        const failed = rows.filter((row: any) => this.logResultBucket(row.status) === 'failed').length;
        const warning = rows.filter((row: any) => this.logResultBucket(row.status) === 'warning').length;
        return { total, success, failed, warning };
    }

    private averageDurationLabel(rows: any[]): string {
        const durations = (rows || []).map((row: any) => this.logDurationSeconds(row)).filter((value: number) => value > 0);
        if (durations.length === 0) return '-';
        const average = Math.round(durations.reduce((sum: number, value: number) => sum + value, 0) / durations.length);
        return this.durationSecondsLabel(average);
    }

    public logStageSummaryRows(): any[] {
        const deploy = this.deployStats();
        const monitoring = this.monitoringStats();
        const deployAverage = this.averageDurationLabel(this.allDeploymentLogRows());
        const monitoringWarning = Math.max(0, Number(monitoring.total || 0) - Number(monitoring.ready || 0) - Number(monitoring.issue || 0));
        return [
            { stage: 'DHCP', success: deploy.deployed, failed: deploy.failed, warning: deploy.in_progress, avg: deployAverage },
            { stage: 'PXE', success: deploy.deployed, failed: deploy.failed, warning: deploy.pending, avg: deployAverage },
            { stage: 'RootFS Transfer', success: deploy.deployed, failed: deploy.failed, warning: deploy.in_progress, avg: deployAverage },
            { stage: 'SSH Bootstrap', success: deploy.deployed, failed: deploy.failed, warning: deploy.pending, avg: deployAverage },
            { stage: 'Monitoring', success: monitoring.ready, failed: monitoring.issue, warning: monitoringWarning, avg: this.averageDurationLabel(this.allMonitoringLogRows()) },
        ];
    }

    public failedWarningTargets(): any[] {
        const targets: any[] = [];
        const seen = new Set<string>();
        for (const node of this.monitoringTargets()) {
            const key = String(node?.id || node?.name || '');
            if (!key || seen.has(key)) continue;
            const bucket = this.nodeDeployBucket(node);
            const issue = this.monitoringIssue(node);
            if (bucket !== 'failed' && !issue) continue;
            seen.add(key);
            targets.push({
                name: node.name || node.ip_address || node.id || 'Node',
                message: issue ? this.monitoringStateLabel(node) : this.nodeStatusLabel(node),
                severity: bucket === 'failed' || issue ? 'failed' : 'warning',
            });
        }
        if (targets.length > 0) return targets.slice(0, 5);
        return this.allLogRows()
            .filter((row: any) => ['failed', 'warning'].includes(this.logResultBucket(row.status)))
            .slice(0, 5)
            .map((row: any) => ({
                name: row.target || row.jobId,
                message: row.message || this.logResultLabel(row),
                severity: this.logResultBucket(row.status),
            }));
    }

    public selectedLogFields(): any[] {
        const row = this.selectedLogRow();
        if (!row) return [];
        return [
            { label: 'ID', value: row.jobId || row.id || '-' },
            { label: 'Type', value: row.typeLabel || row.type || '-' },
            { label: 'Result', value: this.logResultLabel(row) },
            { label: 'Target', value: row.target || '-' },
            { label: 'Start', value: row.started ? this.formatDateTime(row.started) : '-' },
            { label: 'End', value: row.completed ? this.formatDateTime(row.completed) : '-' },
            { label: 'Duration', value: this.logDurationLabel(row) },
            { label: 'User', value: row.user || '-' },
        ];
    }

    public selectedRawLog(): string {
        const row = this.selectedLogRow();
        if (!row) return '';
        try {
            return JSON.stringify(row, null, 2);
        } catch (e) {
            return String(row || '');
        }
    }

    public openGlobalLogs() {
        this.service.href('/kiera/logs');
    }

    public logStatusClass(status: any): string {
        const normalized = this.normalizedStatus(status);
        if (!normalized || ['none', 'new', 'ready', 'idle', 'pending'].includes(normalized)) return 'bg-slate-100 text-slate-600';
        if (normalized.includes('fail') || normalized.includes('error')) return 'bg-rose-100 text-rose-700';
        if (normalized.includes('deploy') || normalized.includes('running')) return 'bg-blue-100 text-blue-700';
        if (['deployed', 'active', 'commissioned', 'completed', 'relay-ready', 'relay_ready'].includes(normalized)) return 'bg-emerald-100 text-emerald-700';
        return 'bg-slate-100 text-slate-600';
    }
}

export default PageKieraClusterDeployItemComponent;
